import { a as S, c as Fe, n as je, o as _e, r as Ue, s as r, t as ke } from "./core-n6tkrASC.js";
import { A as Z, C as q, D as Ee, E as Se, M as Ce, O as xe, S as ze, T as We, _ as Ke, a as Ve, b as z, c as Ye, d as Ge, f as Xe, g as Je, h as Ze, i as Qe, j as et, k as R, l as tt, m as st, n as _, o as ot, r as B, s as it, t as le, v as nt, w as at, x as W, y as w } from "./icons-Btfy6JZ4.js";
var M = {
  name: "pageloop",
  nameTitle: "PageLoop",
  wordmark: {
    head: "page",
    tail: "loop"
  },
  domain: "pageloop.dev",
  scope: "@pageloop"
}, lt = "Anonymous";
function Q(e) {
  const t = e?.trim();
  return t && t.length > 0 ? t : lt;
}
var rt = 32;
function ct(e, t = document) {
  const s = e.toString(), o = pt(e.startContainer), i = o ? Y(o, t) : void 0, { prefix: a, suffix: n } = ht(e, rt);
  return {
    version: 1,
    textFragment: bt(s, a, n),
    cssPath: Y(V(e.startContainer), t),
    xpath: Le(V(e.startContainer), t),
    containerSelector: i,
    startOffset: e.startOffset,
    endOffset: e.endOffset,
    prefix: a,
    suffix: n,
    exact: s
  };
}
function dt(e, t = document) {
  return {
    version: 1,
    cssPath: Y(e, t),
    xpath: Le(e, t),
    elementPicker: !0,
    elementId: e.id || void 0,
    exact: (e.textContent ?? "").slice(0, 200)
  };
}
function V(e) {
  return e.nodeType === Node.ELEMENT_NODE ? e : e.parentElement;
}
function pt(e) {
  let t = V(e);
  for (; t && t !== document.body; ) {
    if (t.id) return t;
    t = t.parentElement;
  }
  return t;
}
function Y(e, t) {
  if (!e) return;
  const s = [];
  let o = e;
  for (; o && o !== t; ) {
    if (o.id)
      return s.unshift(`#${gt(o.id)}`), s.join(" > ");
    const i = o.tagName.toLowerCase(), a = o.parentElement;
    if (a) {
      const n = o.tagName, l = Array.from(a.children).filter((d) => d.tagName === n).indexOf(o) + 1;
      s.unshift(`${i}:nth-of-type(${l})`);
    } else s.unshift(i);
    o = a;
  }
  return s.join(" > ");
}
function Le(e, t) {
  if (!e) return;
  const s = [];
  let o = e;
  for (; o && o !== t; ) {
    const i = o.parentElement;
    if (!i) {
      s.unshift(o.tagName.toLowerCase());
      break;
    }
    const a = o.tagName, n = Array.from(i.children).filter((l) => l.tagName === a).indexOf(o) + 1;
    s.unshift(`${o.tagName.toLowerCase()}[${n}]`), o = i;
  }
  return "/" + s.join("/");
}
function ht(e, t) {
  return {
    prefix: ut(e, t),
    suffix: mt(e, t)
  };
}
function ut(e, t) {
  const s = e.cloneRange(), o = e.startContainer.ownerDocument?.body ?? e.startContainer;
  return s.setStart(o, 0), s.setEnd(e.startContainer, e.startOffset), s.toString().slice(-t);
}
function mt(e, t) {
  const s = e.cloneRange(), o = e.endContainer.ownerDocument;
  if (!o) return "";
  s.setStart(e.endContainer, e.endOffset);
  const i = o.body.lastChild ?? o.body;
  return i.nodeType === Node.TEXT_NODE ? s.setEnd(i, (i.textContent ?? "").length) : s.setEnd(o.body, o.body.childNodes.length), s.toString().slice(0, t);
}
function bt(e, t, s) {
  if (!e) return;
  const o = encodeURIComponent;
  let i = o(e.slice(0, 200));
  return t && (i = `${o(t.slice(-12))}-,${i}`), s && (i = `${i},-${o(s.slice(0, 12))}`), i;
}
function gt(e) {
  return typeof CSS < "u" && typeof CSS.escape == "function" ? CSS.escape(e) : e.replace(/([^\w-])/g, "\\$1");
}
function ft(e, t = document) {
  let s = null;
  const o = t.nodeType === Node.DOCUMENT_NODE ? t : t.ownerDocument ?? document, i = t, a = [], n = /* @__PURE__ */ new Map(), l = (h, b) => {
    if (!h) return;
    let u = n.get(h);
    u || (u = /* @__PURE__ */ new Set(), n.set(h, u), a.push(h)), u.add(b);
  };
  e.elementId && l(o.getElementById?.(e.elementId), "elementId");
  let d = !1;
  if (e.cssPath) try {
    const h = i.querySelectorAll(e.cssPath);
    d = h.length === 1, h.forEach((b) => l(b, "cssPath"));
  } catch {
  }
  if (e.xpath) try {
    l(o.evaluate(e.xpath, t, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue, "xpath");
  } catch {
  }
  const c = re(e.exact ?? "");
  let p = null;
  c && (p = a.find((h) => re(h.textContent ?? "") === c) ?? null), p || (p = a.find((h) => n.get(h)?.has("elementId")) ?? null, !p && d && (p = a.find((h) => n.get(h)?.has("cssPath")) ?? null), p || (p = a.find((h) => n.get(h)?.has("xpath")) ?? null), p || (p = a[0] ?? null));
  const m = p ? [...n.get(p) ?? []] : [];
  if (p && !e.elementPicker) try {
    s = o.createRange(), s.selectNodeContents(p);
  } catch {
    s = null;
  }
  if (!s && !p && e.exact && e.prefix !== void 0 && e.suffix !== void 0) {
    const h = wt(o.body ?? t, e.prefix, e.exact, e.suffix);
    h && (s = h, m.push("fingerprint"));
  }
  if (!s && !p && e.exact) {
    const h = vt(o.body ?? t, e.exact);
    h && (s = h, m.push("exact"));
  }
  return {
    range: s,
    element: p,
    matchedStrategies: m
  };
}
function re(e) {
  return e.replace(/\s+/g, " ").trim().slice(0, 120);
}
function vt(e, t) {
  if (!t) return null;
  const s = e.ownerDocument ?? document, o = s.createTreeWalker(e, NodeFilter.SHOW_TEXT, { acceptNode(v) {
    let E = v.parentNode;
    for (; E && E !== e; ) {
      if (E instanceof Element && E.hasAttribute("data-pageloop")) return NodeFilter.FILTER_REJECT;
      E = E.parentNode;
    }
    return NodeFilter.FILTER_ACCEPT;
  } }), i = [];
  let a = "", n = o.nextNode();
  for (; n; ) {
    const v = n.data;
    i.push({
      node: n,
      start: a.length,
      end: a.length + v.length
    }), a += v, n = o.nextNode();
  }
  const l = a.indexOf(t);
  if (l === -1) return null;
  const d = l, c = l + t.length;
  let p = null, m = 0, h = null, b = 0;
  for (const v of i)
    if (!p && d >= v.start && d <= v.end && (p = v.node, m = d - v.start), !h && c >= v.start && c <= v.end) {
      h = v.node, b = c - v.start;
      break;
    }
  if (!p || !h) return null;
  const u = s.createRange();
  return u.setStart(p, m), u.setEnd(h, b), u;
}
function yt(e, t, s) {
  const o = e.textContent ?? "";
  if (t > o.length || s > o.length) return null;
  const i = (e.ownerDocument ?? document).createTreeWalker(e, NodeFilter.SHOW_TEXT);
  let a = 0, n = null, l = 0, d = null, c = 0, p = i.nextNode();
  for (; p; ) {
    const h = (p.textContent ?? "").length;
    if (!n && a + h >= t && (n = p, l = t - a), !d && a + h >= s) {
      d = p, c = s - a;
      break;
    }
    a += h, p = i.nextNode();
  }
  if (!n || !d) return null;
  const m = (e.ownerDocument ?? document).createRange();
  return m.setStart(n, l), m.setEnd(d, c), m;
}
function wt(e, t, s, o) {
  const i = e.textContent ?? "";
  let a = i.indexOf(t + s + o);
  return a !== -1 ? a += t.length : (a = i.indexOf(t + s), a !== -1 ? a += t.length : (a = i.indexOf(s + o), a === -1 && (a = i.indexOf(s)))), a === -1 ? null : yt(e, a, a + s.length);
}
var _t = {
  placement: "top",
  gap: 8,
  hoverPad: 0,
  viewportPadding: 8,
  autoFlip: !0
}, kt = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
};
function ce(e, t, s, o, i, a) {
  switch (e) {
    case "top":
      return t.top - o - i >= a;
    case "bottom":
      return t.bottom + o + i <= window.innerHeight - a;
    case "left":
      return t.left - s - i >= a;
    case "right":
      return t.right + s + i <= window.innerWidth - a;
  }
}
function Te(e, t, s = {}) {
  const o = {
    ..._t,
    ...s
  }, { gap: i, hoverPad: a, viewportPadding: n, autoFlip: l } = o;
  let { placement: d } = o;
  e.style.left = "0px", e.style.top = "0px";
  const c = t.getBoundingClientRect(), p = e.offsetWidth, m = e.offsetHeight;
  if (l && !ce(d, c, p, m, i, n)) {
    const u = kt[d];
    ce(u, c, p, m, i, n) && (d = u);
  }
  let h, b;
  switch (d) {
    case "top":
      h = c.left + c.width / 2 - p / 2, b = c.top - m - i + a;
      break;
    case "left":
      h = c.left - p - i + a, b = c.top + c.height / 2 - m / 2;
      break;
    case "right":
      h = c.right + i - a, b = c.top + c.height / 2 - m / 2;
      break;
    default:
      h = c.left + c.width / 2 - p / 2, b = c.bottom + i - a;
      break;
  }
  h = Math.max(n, Math.min(h, window.innerWidth - p - n)), b = Math.max(n, Math.min(b, window.innerHeight - m - n)), e.style.left = `${h + window.scrollX}px`, e.style.top = `${b + window.scrollY}px`;
}
var Et = 500, St = 400, Ct = 12, T = null, j = null, K = !1;
function xt() {
  if (K) return () => {
  };
  K = !0;
  const e = (s) => {
    const o = s.target?.closest("[data-pl-tip]");
    if (!o) return;
    const i = o.getAttribute("data-pl-tip");
    i && Pe(o, {
      content: i,
      html: o.getAttribute("data-pl-tip-html") === "1",
      maxWidth: Number(o.getAttribute("data-pl-tip-width")) || void 0
    });
  }, t = (s) => {
    s.target?.closest("[data-pl-tip]") && O();
  };
  return document.addEventListener("mouseover", e, { capture: !0 }), document.addEventListener("mouseout", t, { capture: !0 }), document.addEventListener("scroll", O, {
    capture: !0,
    passive: !0
  }), window.addEventListener("blur", O), () => {
    document.removeEventListener("mouseover", e, { capture: !0 }), document.removeEventListener("mouseout", t, { capture: !0 }), document.removeEventListener("scroll", O, { capture: !0 }), window.removeEventListener("blur", O), O(), T?.remove(), T = null, K = !1;
  };
}
function Pe(e, t) {
  $e();
  const s = t.delay ?? Et;
  j = setTimeout(() => {
    const o = Lt(), i = typeof t.content == "function" ? t.content() : t.content;
    if (i == null || i === "") {
      O();
      return;
    }
    const a = t.fontSize ?? Ct, n = t.maxWidth ?? St, l = t.minWidth ?? 0;
    o.style.maxWidth = `${n}px`, o.style.minWidth = l > 0 ? `${l}px` : "", o.style.fontSize = `${a}px`, typeof i == "string" ? t.html ? o.innerHTML = i : o.textContent = i : o.replaceChildren(i), Tt(o, e, t.placement ?? "top"), o.style.opacity = "1", o.style.pointerEvents = "none";
  }, s);
}
function O() {
  $e(), T && (T.style.opacity = "0");
}
function $e() {
  j != null && (clearTimeout(j), j = null);
}
function Lt() {
  return T && T.isConnected || (T = document.createElement("div"), T.className = "pl-tooltip", T.setAttribute("role", "tooltip"), T.dataset.pageloop = "tooltip", T.style.position = "absolute", T.style.opacity = "0", T.style.pointerEvents = "none", document.body.appendChild(T)), T;
}
function Tt(e, t, s) {
  Te(e, t, { placement: s });
}
function Pt(e, t) {
  const s = () => Pe(e, t), o = O;
  return e.addEventListener("mouseenter", s), e.addEventListener("mouseleave", o), () => {
    e.removeEventListener("mouseenter", s), e.removeEventListener("mouseleave", o);
  };
}
var $t = {
  install: xt,
  attach: Pt,
  hide: O
}, At = 200, Mt = 0, Rt = 2e3, Ot = 8, It = 100, de = 200, Bt = 15, Ht = class {
  constructor(e, t = {}) {
    r(this, "comments", void 0), r(this, "opts", void 0), r(this, "node", null), r(this, "current", null), r(this, "sticky", !1), r(this, "focusedReply", !1), r(this, "pendingShow", null), r(this, "pendingLeave", null), r(this, "boundEls", /* @__PURE__ */ new WeakMap()), r(this, "outsideClickHandler", null), r(this, "escHandler", null), r(this, "scrollHandler", null), r(this, "openSidebar", null), this.comments = e, this.opts = {
      placement: "bottom",
      ...t
    };
  }
  delay() {
    const e = this.opts.delayMs ?? At;
    return Math.max(Mt, Math.min(Rt, e));
  }
  updateOptions(e) {
    Object.assign(this.opts, e);
  }
  setOpenSidebar(e) {
    this.openSidebar = e;
  }
  bind(e, t, s = {}) {
    const o = this.boundEls.get(e);
    o && o.detach();
    const i = s.bindClick !== !1, a = () => this.openHover(e, t), n = () => this.queueLeave(), l = (c) => {
      c.preventDefault(), c.stopPropagation(), this.openSticky(e, t);
    };
    e.addEventListener("mouseenter", a), e.addEventListener("mouseleave", n), i && e.addEventListener("click", l);
    const d = () => {
      e.removeEventListener("mouseenter", a), e.removeEventListener("mouseleave", n), i && e.removeEventListener("click", l), this.boundEls.delete(e);
    };
    return this.boundEls.set(e, { detach: d }), d;
  }
  openHover(e, t) {
    this.sticky || (this.cancelLeave(), this.cancelPending(), this.pendingShow = setTimeout(() => {
      this.show(e, t, !1);
    }, this.delay()));
  }
  openSticky(e, t) {
    if (this.cancelLeave(), this.cancelPending(), this.current?.id === t.id && this.node && this.node.style.opacity !== "0") {
      this.sticky = !0, this.node.classList.add("pl-ctooltip--sticky"), this.attachGlobalDismiss();
      return;
    }
    this.show(e, t, !0);
  }
  buildHandlers(e) {
    return {
      sticky: this.sticky,
      replies: this.comments.loadedReplies(e.id)?.length ?? null,
      onReply: async (t, s) => {
        const o = t.trim();
        if (o) {
          await this.comments.reply(e.id, o, s);
          try {
            await this.comments.fetchReplies(e.id);
          } catch {
          }
          this.current?.id === e.id && this.refreshContents();
        }
      },
      onOpenSidebar: () => {
        this.openSidebar?.(e.id), this.close();
      },
      onClose: () => this.close()
    };
  }
  show(e, t, s) {
    const o = this.ensureNode();
    this.sticky = s, this.current = t;
    const i = this.buildHandlers(t), a = this.opts.render ? this.opts.render(t, i) : this.renderDefault(t, i);
    o.replaceChildren(a), o.style.pointerEvents = "auto", o.classList.toggle("pl-ctooltip--sticky", s), this.place(o, e), o.style.opacity = "1", this.attachGlobalDismiss();
  }
  refreshContents() {
    const e = this.current, t = this.node;
    if (!e || !t) return;
    const s = this.buildHandlers(e), o = this.opts.render ? this.opts.render(e, s) : this.renderDefault(e, s);
    t.replaceChildren(o);
  }
  queueLeave() {
    this.sticky || this.focusedReply || (this.cancelPending(), this.cancelLeave(), this.pendingLeave = setTimeout(() => this.close(), It));
  }
  close() {
    this.cancelPending(), this.cancelLeave(), this.sticky = !1, this.focusedReply = !1, this.current = null, this.node && (this.node.style.opacity = "0", this.node.classList.remove("pl-ctooltip--sticky")), this.detachGlobalDismiss();
  }
  destroy() {
    this.close(), this.detachGlobalDismiss(), this.node?.remove(), this.node = null;
  }
  ensureNode() {
    if (this.node && this.node.isConnected) return this.node;
    const e = document.createElement("div");
    return e.className = "pl-ctooltip", e.setAttribute("role", "tooltip"), e.dataset.pageloop = "comment-tooltip", e.style.position = "absolute", e.style.opacity = "0", e.style.pointerEvents = "auto", e.addEventListener("mouseenter", () => this.cancelLeave()), e.addEventListener("mouseleave", () => {
      this.sticky || this.queueLeave();
    }), document.body.appendChild(e), this.node = e, e;
  }
  cancelPending() {
    this.pendingShow != null && (clearTimeout(this.pendingShow), this.pendingShow = null);
  }
  cancelLeave() {
    this.pendingLeave != null && (clearTimeout(this.pendingLeave), this.pendingLeave = null);
  }
  attachGlobalDismiss() {
    this.detachGlobalDismiss(), this.sticky && (this.outsideClickHandler = (e) => {
      const t = e.target;
      t && this.node && !this.node.contains(t) && this.close();
    }, document.addEventListener("mousedown", this.outsideClickHandler, { capture: !0 }), this.escHandler = (e) => {
      e.key === "Escape" && this.close();
    }, document.addEventListener("keydown", this.escHandler)), this.scrollHandler = () => {
      this.focusedReply || this.close();
    }, window.addEventListener("scroll", this.scrollHandler, {
      passive: !0,
      capture: !0
    });
  }
  detachGlobalDismiss() {
    this.outsideClickHandler && (document.removeEventListener("mousedown", this.outsideClickHandler, { capture: !0 }), this.outsideClickHandler = null), this.escHandler && (document.removeEventListener("keydown", this.escHandler), this.escHandler = null), this.scrollHandler && (window.removeEventListener("scroll", this.scrollHandler, { capture: !0 }), this.scrollHandler = null);
  }
  place(e, t) {
    Te(e, t, {
      placement: this.opts.placement,
      gap: 8,
      hoverPad: Bt,
      viewportPadding: Ot
    });
  }
  renderDefault(e, t) {
    const s = document.createElement("div");
    s.className = "pl-ctooltip__card";
    const o = document.createElement("button");
    o.type = "button", o.className = "pl-ctooltip__header", o.title = "Open in sidebar", o.addEventListener("click", (p) => {
      p.preventDefault(), t.onOpenSidebar();
    });
    const i = document.createElement("span");
    i.className = "pl-ctooltip__avatar", i.textContent = q(e.authorName ?? "?").charAt(0), o.appendChild(i);
    const a = document.createElement("span");
    a.className = "pl-ctooltip__author", a.textContent = Q(e.authorName), o.appendChild(a);
    const n = document.createElement("span");
    n.className = "pl-ctooltip__time", n.textContent = "· " + Ce(e.createdAt, {
      style: "compact",
      nullLabel: ""
    }), o.appendChild(n);
    const l = document.createElement("button");
    l.type = "button", l.className = "pl-ctooltip__x", l.setAttribute("aria-label", "Close"), l.textContent = "×", l.addEventListener("click", (p) => {
      p.preventDefault(), p.stopPropagation(), t.onClose();
    }), o.appendChild(l), s.appendChild(o);
    const d = document.createElement("div");
    if (d.className = "pl-ctooltip__body", d.textContent = (e.bodyMd ?? "").trim() || "(empty comment)", s.appendChild(d), t.replies != null && t.replies > 0) {
      const p = document.createElement("button");
      p.type = "button", p.className = "pl-ctooltip__replies", p.textContent = t.replies === 1 ? "1 reply · open thread →" : `${t.replies} replies · open thread →`, p.addEventListener("click", (m) => {
        m.preventDefault(), t.onOpenSidebar();
      }), s.appendChild(p);
    }
    const c = this.resolveAffordance();
    return c !== "hidden" && s.appendChild(this.renderReplyInput(t, c === "guest")), s;
  }
  resolveAffordance() {
    return this.opts.replyAffordance ? this.opts.replyAffordance() : this.opts.allowReply ? "user" : "hidden";
  }
  renderReplyInput(e, t) {
    const s = document.createElement("form");
    s.className = "pl-ctooltip__reply";
    let o = null;
    t && (o = document.createElement("input"), o.className = "pl-ctooltip__reply-name", o.type = "text", o.placeholder = "Your name", o.maxLength = 60, o.value = S.getItem("pl_guest_name") ?? "", o.addEventListener("focus", () => {
      this.focusedReply = !0, this.cancelLeave(), this.cancelPending(), !this.sticky && this.node && (this.sticky = !0, this.node.classList.add("pl-ctooltip--sticky"), this.attachGlobalDismiss());
    }), o.addEventListener("blur", () => {
      this.focusedReply = !1;
    }), s.appendChild(o));
    const i = document.createElement("textarea");
    i.className = "pl-ctooltip__reply-input", i.placeholder = "Reply…", i.rows = 1;
    const a = () => {
      i.style.height = "auto";
      const d = Math.min(i.scrollHeight, de);
      i.style.height = `${d}px`, i.style.overflowY = i.scrollHeight > de ? "auto" : "hidden";
    };
    i.addEventListener("input", a), i.addEventListener("keydown", (d) => {
      (d.metaKey || d.ctrlKey) && d.key === "Enter" && (d.preventDefault(), l()), d.key === "Escape" && e.onClose();
    }), i.addEventListener("focus", () => {
      this.focusedReply = !0, this.cancelLeave(), this.cancelPending(), !this.sticky && this.node && (this.sticky = !0, this.node.classList.add("pl-ctooltip--sticky"), this.attachGlobalDismiss());
    }), i.addEventListener("blur", () => {
      this.focusedReply = !1;
    });
    const n = document.createElement("button");
    n.type = "submit", n.className = "pl-ctooltip__reply-send", n.setAttribute("aria-label", "Send reply"), n.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l14-7-7 14-2-5z"/></svg>';
    const l = async () => {
      const d = i.value.trim();
      if (!d || n.hasAttribute("disabled")) return;
      let c;
      if (o) {
        if (c = o.value.trim(), !c) {
          o.focus();
          return;
        }
        S.setItem("pl_guest_name", c);
      }
      n.setAttribute("disabled", "1");
      try {
        await e.onReply(d, c), i.value = "", a();
      } finally {
        n.removeAttribute("disabled");
      }
    };
    return s.addEventListener("submit", (d) => {
      d.preventDefault(), l();
    }), s.appendChild(i), s.appendChild(n), s;
  }
}, qt = 2e3, Nt = 6e3, Dt = 160, Ft = class {
  constructor() {
    r(this, "host", null);
  }
  attach(e) {
    e.on("toast:show", (t) => this.show(t));
  }
  show(e) {
    const t = this.ensureHost(), s = document.createElement("div");
    s.className = `pl-toast pl-toast--${e.kind}`, s.textContent = e.message, s.addEventListener("click", () => this.dismiss(s)), t.appendChild(s), requestAnimationFrame(() => s.classList.add("pl-toast--in"));
    const o = e.duration === 0 ? 0 : e.duration ?? (e.kind === "error" ? Nt : qt);
    o > 0 && setTimeout(() => this.dismiss(s), o);
  }
  dismiss(e) {
    e.isConnected && (e.classList.remove("pl-toast--in"), e.classList.add("pl-toast--out"), setTimeout(() => e.remove(), Dt));
  }
  ensureHost() {
    if (this.host?.isConnected) return this.host;
    const e = document.createElement("div");
    return e.className = "pl-toast-host", document.body.appendChild(e), this.host = e, e;
  }
  destroy() {
    this.host?.remove(), this.host = null;
  }
}, U = "0.7.4", I = class {
  constructor() {
    r(this, "el", null), r(this, "anchor", null), r(this, "prevFocus", null), r(this, "onOutsideClick", (e) => {
      if (!this.el) return;
      const t = e.target;
      this.el.contains(t) || this.anchor?.contains(t) || this.close();
    }), r(this, "onKeydown", (e) => {
      e.key === "Escape" && (e.stopPropagation(), this.close());
    });
  }
  open(e, t, s = "auto") {
    this.close(), document.body.appendChild(e), this.position(e, t, s), this.el = e, this.anchor = t, this.prevFocus = document.activeElement instanceof HTMLElement ? document.activeElement : t, (e.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])') ?? e).focus?.(), setTimeout(() => {
      document.addEventListener("click", this.onOutsideClick), document.addEventListener("keydown", this.onKeydown);
    }, 0);
  }
  close() {
    const e = !!this.el;
    this.el?.remove(), this.el = null, this.anchor = null, document.removeEventListener("click", this.onOutsideClick), document.removeEventListener("keydown", this.onKeydown), e && this.prevFocus?.focus?.(), this.prevFocus = null;
  }
  isOpen() {
    return !!this.el;
  }
  position(e, t, s) {
    const o = t.getBoundingClientRect(), i = s === "top" || s === "auto" && document.body.classList.contains("pl-toolbar-bottom");
    e.style.position = "fixed", i ? (e.style.bottom = `${Math.max(8, window.innerHeight - o.top + 6)}px`, e.style.top = "auto") : (e.style.top = `${o.bottom + 6}px`, e.style.bottom = "auto"), e.style.right = `${Math.max(8, window.innerWidth - o.right)}px`, e.style.left = "auto", requestAnimationFrame(() => {
      e.getBoundingClientRect().left < 8 && (e.style.right = "auto", e.style.left = "8px");
    });
  }
}, jt = /* @__PURE__ */ new Set([
  "auto",
  "light",
  "dark"
]), Ut = {
  "corporate-blue": {
    base: "light",
    css: `[data-pl-theme="light"] {
  /* Surface — keep light defaults, nudge with very subtle blue tints. */
  --pl-color-surface-muted: #f6f9ff;
  --pl-color-surface-sunken: #eaf2ff;
  --pl-color-border: #c8daf2;
  --pl-color-border-strong: #a4c0e8;
  --pl-color-border-subtle: #eef4fc;

  /* Text — slate-ish, slightly cool. */
  --pl-color-text: #0c1d33;
  --pl-color-text-muted: #2e4a72;
  --pl-color-text-soft: #4a6691;
  --pl-color-text-faint: #7a8fab;

  /* Brand */
  --pl-color-primary: #0f62fe;
  --pl-color-primary-hover: #0043ce;
  --pl-color-primary-soft: #d0e2ff;
  --pl-color-primary-soft-border: #78a9ff;
  --pl-color-primary-subtle-bg: #edf5ff;

  /* Focus ring matches the brand. */
  --pl-focus-ring: 0 0 0 2px rgba(15, 98, 254, 0.4);

  /* Comment tooltip — keep dark obsidian; just retune accent + avatar. */
  --pl-ctooltip-accent: #78a9ff;
  --pl-ctooltip-avatar-bg: linear-gradient(135deg, #4589ff 0%, #0043ce 100%);

  /* Bubble marker — one base hue drives the family. */
  --pl-bubble-base: #4589ff;
  --pl-bubble-bg: linear-gradient(135deg, var(--pl-bubble-base) 0%, #0043ce 100%);
  --pl-bubble-ring: rgba(69, 137, 255, 0.55);
  --pl-bubble-glow: 0 6px 18px -6px rgba(0, 67, 206, 0.55), 0 0 0 1px rgba(255, 255, 255, 0.06);
  --pl-bubble-flash: rgba(69, 137, 255, 0.55);
  --pl-bubble-flash-bg: rgba(69, 137, 255, 0.5);
  --pl-bubble-flash-bg-trans: rgba(69, 137, 255, 0);
  --pl-bubble-anchor-highlight: rgba(69, 137, 255, 0.22);
  --pl-bubble-soft-glow: rgba(69, 137, 255, 0.45);

  /* Toolbar — saturated navy for the docked strip. */
  --pl-color-toolbar-bg: #0a2a5c;
  --pl-color-toolbar-fg: #eaf2ff;
  --pl-color-toolbar-btn-border: rgba(120, 169, 255, 0.30);
  --pl-color-toolbar-btn-hover: rgba(120, 169, 255, 0.12);

  /* Mini widget — recompose via stops; accent + glow follow blue. The
     surface is now navy, so the foreground (mini count + the "Comment on
     this" selection affordance) must be light, matching the sidebar fg —
     the light-base default (#1e293b) would read black-on-navy. */
  --pl-mini-fg: #eaf2ff;
  --pl-mini-bg-stop-1: #0f62fe;
  --pl-mini-bg-stop-2: #0043ce;
  --pl-mini-bg-stop-3: #002d9c;
  --pl-mini-accent: #78a9ff;
  --pl-mini-accent-soft: rgba(120, 169, 255, 0.20);
  --pl-mini-bg-glow: radial-gradient(ellipse 75% 75% at 30% 28%, rgba(120, 169, 255, 0.30) 0%, rgba(120, 169, 255, 0) 60%);
  --pl-mini-btn-active-bg: linear-gradient(135deg, rgba(120, 169, 255, 0.34) 0%, rgba(120, 169, 255, 0.10) 100%);

  /* Wordmark — "docs" picks up the brand. */
  --pl-mini-logo-fg-docs: rgba(120, 169, 255, 0.92);
  --pl-mini-logo-shadow-docs: 0 0 6px rgba(120, 169, 255, 0.20), 0 1px 0 rgba(0, 0, 0, 0.45);
  --pl-mini-logo-hover-glow-docs: 0 0 12px rgba(120, 169, 255, 0.55), 0 1px 0 rgba(0, 0, 0, 0.45);

}
/* Sidebar — navy chrome (toolbar / mini family) rather than the light host
   surface, so the comment panel reads as part of the same widget. */
[data-pl-theme="light"] .pl-sidebar {
  --pl-color-surface: #0a2a5c;
  --pl-color-surface-muted: #0c326b;
  --pl-color-surface-sunken: #103d7d;
  --pl-color-text: #eaf2ff;
  --pl-color-text-muted: #c2d6f5;
  --pl-color-text-soft: #9bbcea;
  --pl-color-text-faint: #7396cc;
  --pl-color-border: #1d4a8a;
  --pl-color-border-strong: #2a5aa0;
  /* Selected comment — only a shade lighter than the panel so light text
     stays readable (was a near-white tint that washed the text out). */
  --pl-color-primary-subtle-bg: #103a72;
}`
  },
  "mocha-mornings": {
    base: "dark",
    css: `@import url('https://fonts.googleapis.com/css2?family=Marcellus&family=Source+Serif+4:ital,opsz,wght@0,8..60,400;0,8..60,500;0,8..60,600;1,8..60,400&display=swap');
[data-pl-theme="dark"] {
  /* Typography — editorial serif body; simple system stack for meta. */
  --pl-font-sans: "Source Serif 4", ui-serif, Georgia, "Times New Roman", serif;
  --pl-font-mono: ui-monospace, SFMono-Regular, Menlo, monospace;

  /* Surface — warm graphite "coffee" ramp (WristLeo --surface scale). */
  --pl-color-surface: oklch(0.247 0.005 78);
  --pl-color-surface-muted: oklch(0.285 0.008 72);
  --pl-color-surface-sunken: oklch(0.31 0.009 72);
  --pl-color-border: oklch(0.37 0.008 76);
  --pl-color-border-strong: oklch(0.46 0.012 80);
  --pl-color-border-subtle: oklch(0.31 0.006 78);

  /* Ink — warm cream (WristLeo --ink scale). */
  --pl-color-text: oklch(0.965 0.005 85);
  --pl-color-text-muted: oklch(0.805 0.006 80);
  --pl-color-text-soft: oklch(0.625 0.006 78);
  --pl-color-text-faint: oklch(0.52 0.006 78);

  /* Brand — luminous champagne gold (the only accent). */
  --pl-color-primary: oklch(0.84 0.06 86);
  --pl-color-primary-hover: oklch(0.9 0.055 88);
  --pl-color-primary-soft: oklch(0.32 0.04 70);
  --pl-color-primary-soft-border: oklch(0.5 0.06 80);
  --pl-color-primary-subtle-bg: oklch(0.3 0.03 72);

  /* Semantic state — warm-shifted so nothing reads cool. */
  --pl-color-danger-bg: oklch(0.26 0.05 30);
  --pl-color-danger-border: oklch(0.45 0.10 32);
  --pl-color-success-bg: oklch(0.3 0.04 150);
  --pl-color-warn-bg: oklch(0.32 0.05 80);
  --pl-color-excerpt-bg: oklch(0.32 0.035 78);

  /* Focus ring — champagne gold. */
  --pl-focus-ring: 0 0 0 2px oklch(0.84 0.06 86 / 0.5);

  /* Shadows — deep + warm-brown cast (WristLeo depth). */
  --pl-shadow-sidebar: -2px 0 16px oklch(0.12 0.01 60 / 0.55);
  --pl-shadow-popover: 0 24px 56px -30px oklch(0.1 0.01 60 / 0.8), 0 1px 0 oklch(0.99 0.01 90 / 0.06) inset;
  --pl-shadow-popover-sm: 0 8px 22px -16px oklch(0.1 0.01 60 / 0.75), 0 1px 0 oklch(0.99 0.01 90 / 0.06) inset;

  /* Comment tooltip — deep warm card, gold accent. */
  --pl-ctooltip-bg: oklch(0.165 0.006 72 / 0.96);
  --pl-ctooltip-stroke: oklch(0.84 0.06 86 / 0.18);
  --pl-ctooltip-fg: oklch(0.965 0.005 85);
  --pl-ctooltip-fg-soft: oklch(0.805 0.006 80);
  --pl-ctooltip-fg-faint: oklch(0.625 0.006 78);
  --pl-ctooltip-accent: oklch(0.84 0.06 86);
  --pl-ctooltip-avatar-bg: linear-gradient(135deg, oklch(0.84 0.06 86) 0%, oklch(0.66 0.085 78) 100%);
  --pl-ctooltip-reply-bg: oklch(0.84 0.06 86 / 0.05);
  --pl-ctooltip-reply-stroke: oklch(0.84 0.06 86 / 0.12);

  /* Bubble marker — champagne gold gradient. */
  --pl-bubble-base: oklch(0.78 0.075 84);
  --pl-bubble-bg: linear-gradient(135deg, oklch(0.84 0.06 86) 0%, oklch(0.66 0.085 78) 100%);
  --pl-bubble-ring: oklch(0.84 0.06 86 / 0.5);
  --pl-bubble-glow: 0 6px 18px -6px oklch(0.66 0.085 78 / 0.5), 0 0 0 1px oklch(0.99 0.01 90 / 0.06);
  --pl-bubble-flash: oklch(0.84 0.06 86 / 0.55);
  --pl-bubble-flash-bg: oklch(0.84 0.06 86 / 0.45);
  --pl-bubble-flash-bg-trans: oklch(0.84 0.06 86 / 0);
  --pl-bubble-anchor-highlight: oklch(0.84 0.06 86 / 0.24);
  --pl-bubble-soft-glow: oklch(0.84 0.06 86 / 0.42);

  /* Toolbar — warm mocha chrome with a gold-lit top edge. */
  --pl-color-toolbar-bg: oklch(0.265 0.016 66);
  --pl-color-toolbar-fg: oklch(0.965 0.005 85);
  --pl-color-toolbar-btn-border: oklch(0.84 0.06 86 / 0.22);
  --pl-color-toolbar-btn-hover: oklch(0.84 0.06 86 / 0.10);
  --pl-color-toolbar-shadow: oklch(0.1 0.01 60 / 0.5);
  --pl-color-toolbar-edge: oklch(0.84 0.06 86 / 0.26);

  /* Mini widget — warm mocha gradient, gold accent. */
  --pl-mini-bg-stop-1: oklch(0.31 0.018 66);
  --pl-mini-bg-stop-2: oklch(0.25 0.016 64);
  --pl-mini-bg-stop-3: oklch(0.18 0.012 62);
  --pl-mini-fg: oklch(0.965 0.005 85);
  --pl-mini-accent: oklch(0.84 0.06 86);
  --pl-mini-accent-soft: oklch(0.84 0.06 86 / 0.20);
  --pl-mini-stroke: oklch(0.84 0.06 86 / 0.14);
  --pl-mini-bg-glow: radial-gradient(ellipse 75% 75% at 30% 28%, oklch(0.84 0.06 86 / 0.22) 0%, oklch(0.84 0.06 86 / 0) 60%);
  --pl-mini-btn-active-bg: linear-gradient(135deg, oklch(0.84 0.06 86 / 0.32) 0%, oklch(0.84 0.06 86 / 0.10) 100%);

  /* Wordmark — "docs" in champagne gold. */
  --pl-mini-logo-fg-docs: oklch(0.84 0.06 86 / 0.92);
  --pl-mini-logo-shadow-docs: 0 0 6px oklch(0.84 0.06 86 / 0.2), 0 1px 0 oklch(0.1 0.01 60 / 0.45);
  --pl-mini-logo-hover-glow-docs: 0 0 12px oklch(0.84 0.06 86 / 0.5), 0 1px 0 oklch(0.1 0.01 60 / 0.45);

  /* Corners — gently rounded everywhere (WristLeo radius scale). */
  --pl-radius-sm: 8px;
  --pl-radius-md: 11px;
  --pl-radius-lg: 14px;
  --pl-mini-corner-radius-x: 20px;
  --pl-mini-corner-radius-y: 20px;
}
/* Headers — Marcellus on the brand wordmarks for the boutique register.
   Body stays Source Serif 4 (via --pl-font-sans); meta stays system. */
[data-pl-theme="dark"] .pl-toolbar__title,
[data-pl-theme="dark"] .pl-sidebar__title,
[data-pl-theme="dark"] .pl-mini__logo {
  font-family: "Marcellus", "Cormorant Garamond", Georgia, serif;
  letter-spacing: 0.01em;
}
/* Subtle top-lit gradient on the toolbar chrome (surface-hi → surface). */
[data-pl-theme="dark"] .pl-toolbar {
  background-image: linear-gradient(180deg, oklch(0.3 0.018 66), oklch(0.245 0.015 66));
}
/* Sidebar — warm mocha panel, cream ink, gold selection, with a soft
   top-lit gradient so it reads as elegant chrome rather than a flat box. */
[data-pl-theme="dark"] .pl-sidebar {
  --pl-color-surface: oklch(0.265 0.014 66);
  --pl-color-surface-muted: oklch(0.245 0.013 66);
  --pl-color-surface-sunken: oklch(0.3 0.015 66);
  --pl-color-text: oklch(0.965 0.005 85);
  --pl-color-text-muted: oklch(0.83 0.008 78);
  --pl-color-text-soft: oklch(0.66 0.008 76);
  --pl-color-text-faint: oklch(0.55 0.008 76);
  --pl-color-border: oklch(0.4 0.012 70);
  --pl-color-border-strong: oklch(0.48 0.014 72);
  /* Selected comment — a warm deep mocha (not the default blue tint). */
  --pl-color-primary-subtle-bg: oklch(0.33 0.035 66);
  background-image: linear-gradient(180deg, oklch(0.295 0.016 66), oklch(0.25 0.013 66));
}`
  },
  "brutalist-warm": {
    base: "dark",
    css: `[data-pl-theme="dark"] {
  /* Typography — slab-mono identity. */
  --pl-font-sans: "JetBrains Mono", ui-monospace, SFMono-Regular, monospace;

  /* Surface — deep burgundy / mahogany ramp. */
  --pl-color-surface: #1c0d08;
  --pl-color-surface-muted: #2a1410;
  --pl-color-surface-sunken: #3a1c15;
  --pl-color-border: #4a2418;
  --pl-color-border-strong: #5e2e1f;
  --pl-color-border-subtle: #2e1612;

  /* Text — warm cream, no cool tones. */
  --pl-color-text: #f4ebe5;
  --pl-color-text-muted: #d4baa7;
  --pl-color-text-soft: #b39682;
  --pl-color-text-faint: #856d5d;

  /* Brand — burnt orange, the workshop highlight. */
  --pl-color-primary: #fb923c;
  --pl-color-primary-hover: #fdba74;
  --pl-color-primary-soft: #5b1f0a;
  --pl-color-primary-soft-border: #7c2d12;
  --pl-color-primary-subtle-bg: #2a1410;

  /* Semantic state — keep redshift palette for danger; warm warn. */
  --pl-color-danger-bg: #2a0a08;
  --pl-color-danger-border: #5b1410;
  --pl-color-success-bg: #1a2008;
  --pl-color-warn-bg: #2e1c08;
  --pl-color-excerpt-bg: #3a2a10;

  /* Focus ring */
  --pl-focus-ring: 0 0 0 2px rgba(251, 146, 60, 0.5);

  /* Shadows — deeper for the dark surface. */
  --pl-shadow-sidebar: -2px 0 12px rgba(0, 0, 0, 0.5);
  --pl-shadow-popover: 0 8px 24px rgba(0, 0, 0, 0.6);
  --pl-shadow-popover-sm: 0 4px 12px rgba(0, 0, 0, 0.5);

  /* Comment tooltip — obsidian card stays, accent flips to orange. */
  --pl-ctooltip-bg: rgba(20, 8, 6, 0.96);
  --pl-ctooltip-stroke: rgba(251, 146, 60, 0.18);
  --pl-ctooltip-accent: #fb923c;
  --pl-ctooltip-avatar-bg: linear-gradient(135deg, #fb923c 0%, #7c2d12 100%);
  --pl-ctooltip-reply-bg: rgba(251, 146, 60, 0.06);
  --pl-ctooltip-reply-stroke: rgba(251, 146, 60, 0.14);

  /* Bubble marker */
  --pl-bubble-base: #c2410c;
  --pl-bubble-bg: linear-gradient(135deg, var(--pl-bubble-base) 0%, #7c2d12 100%);
  --pl-bubble-ring: rgba(194, 65, 12, 0.5);
  --pl-bubble-glow: 0 4px 12px -4px rgba(124, 45, 18, 0.45), 0 0 0 1px rgba(255, 255, 255, 0.06);
  --pl-bubble-flash: rgba(194, 65, 12, 0.55);
  --pl-bubble-flash-bg: rgba(194, 65, 12, 0.5);
  --pl-bubble-flash-bg-trans: rgba(194, 65, 12, 0);
  --pl-bubble-anchor-highlight: rgba(194, 65, 12, 0.28);
  --pl-bubble-soft-glow: rgba(194, 65, 12, 0.45);

  /* Toolbar — burnt-orange sienna to match the sidebar chrome (was a
     near-black mahogany that, under the shared blue top-edge, read as a
     dark-blue strip). The luminous top edge is retinted warm so no blue
     leaks in on the dark base. */
  --pl-color-toolbar-bg: #7c2d12;
  --pl-color-toolbar-fg: #f4ebe5;
  --pl-color-toolbar-btn-border: rgba(251, 146, 60, 0.28);
  --pl-color-toolbar-btn-hover: rgba(251, 146, 60, 0.12);
  --pl-color-toolbar-shadow: rgba(0, 0, 0, 0.55);
  --pl-color-toolbar-edge: rgba(251, 146, 60, 0.30);

  /* Mini widget */
  --pl-mini-bg-stop-1: #7c2d12;
  --pl-mini-bg-stop-2: #5b1f0a;
  --pl-mini-bg-stop-3: #2a0e04;
  --pl-mini-accent: #fb923c;
  --pl-mini-accent-soft: rgba(251, 146, 60, 0.20);
  --pl-mini-stroke: rgba(251, 146, 60, 0.14);
  --pl-mini-bg-glow: radial-gradient(ellipse 75% 75% at 30% 28%, rgba(251, 146, 60, 0.22) 0%, rgba(251, 146, 60, 0) 60%);
  --pl-mini-btn-active-bg: linear-gradient(135deg, rgba(251, 146, 60, 0.34) 0%, rgba(251, 146, 60, 0.10) 100%);

  /* Wordmark — "docs" in burnt orange. */
  --pl-mini-logo-fg-docs: rgba(251, 146, 60, 0.92);
  --pl-mini-logo-shadow-docs: 0 0 6px rgba(251, 146, 60, 0.18), 0 1px 0 rgba(0, 0, 0, 0.45);
  --pl-mini-logo-hover-glow-docs: 0 0 12px rgba(251, 146, 60, 0.55), 0 1px 0 rgba(0, 0, 0, 0.45);

  /* Corners — sharper, less stretched. */
  --pl-mini-corner-radius-x: 22px;
  --pl-mini-corner-radius-y: 22px;

  /* Radii — slab energy = squarer chrome. */
  --pl-radius-sm: 2px;
  --pl-radius-md: 3px;
  --pl-radius-lg: 4px;

}
/* Sidebar — the warm burnt-orange of the mini widget, with cream text.
   Deliberately NOT the near-black surface burgundy: the panel reads as the
   same warm chrome as the corner bubble. */
[data-pl-theme="dark"] .pl-sidebar {
  --pl-color-surface: #7c2d12;
  --pl-color-surface-muted: #722a11;
  --pl-color-surface-sunken: #85311a;
  --pl-color-text: #f4ebe5;
  --pl-color-text-muted: #eccbb4;
  --pl-color-text-soft: #d8a888;
  --pl-color-text-faint: #bd8866;
  --pl-color-border: #92400e;
  --pl-color-border-strong: #a8480e;
  /* Selected comment — a darker burnt orange (was the dark-theme blue). */
  --pl-color-primary-subtle-bg: #5e2109;
}`
  },
  "brutalist-light": {
    base: "light",
    css: `[data-pl-theme="light"] {
  /* Typography — same mono identity as Brutalist Warm. */
  --pl-font-sans: "JetBrains Mono", ui-monospace, SFMono-Regular, monospace;

  /* Surface — warm cream ramp, not pure white. */
  --pl-color-surface: #faf7f2;
  --pl-color-surface-muted: #f1ebe1;
  --pl-color-surface-sunken: #e8dfd0;
  --pl-color-border: #d4c8b3;
  --pl-color-border-strong: #b8a88a;
  --pl-color-border-subtle: #ede5d4;

  /* Text — warm dark. */
  --pl-color-text: #292524;
  --pl-color-text-muted: #57534e;
  --pl-color-text-soft: #78716c;
  --pl-color-text-faint: #a8a29e;

  /* Brand — standard link blue (replaces burgundy). */
  --pl-color-primary: #0f62fe;
  --pl-color-primary-hover: #0043ce;
  --pl-color-primary-soft: #d0e2ff;
  --pl-color-primary-soft-border: #78a9ff;
  --pl-color-primary-subtle-bg: #edf5ff;

  /* Focus ring follows the new blue. */
  --pl-focus-ring: 0 0 0 2px rgba(15, 98, 254, 0.4);

  /* Excerpt highlight — keep the warm parchment feel. */
  --pl-color-excerpt-bg: #fef3c7;

  /* Comment tooltip — keep dark obsidian; accent + avatar use blue. */
  --pl-ctooltip-accent: #4589ff;
  --pl-ctooltip-avatar-bg: linear-gradient(135deg, #4589ff 0%, #0043ce 100%);

  /* Bubble marker — blue family. */
  --pl-bubble-base: #4589ff;
  --pl-bubble-bg: linear-gradient(135deg, var(--pl-bubble-base) 0%, #0043ce 100%);
  --pl-bubble-ring: rgba(69, 137, 255, 0.55);
  --pl-bubble-glow: 0 6px 18px -6px rgba(0, 67, 206, 0.55), 0 0 0 1px rgba(255, 255, 255, 0.06);
  --pl-bubble-flash: rgba(69, 137, 255, 0.55);
  --pl-bubble-flash-bg: rgba(69, 137, 255, 0.5);
  --pl-bubble-flash-bg-trans: rgba(69, 137, 255, 0);
  --pl-bubble-anchor-highlight: rgba(69, 137, 255, 0.22);
  --pl-bubble-soft-glow: rgba(69, 137, 255, 0.45);

  /* Toolbar — warm cream, like the rest of the chrome. */
  --pl-color-toolbar-bg: #f1ebe1;
  --pl-color-toolbar-fg: #292524;
  --pl-color-toolbar-btn-border: rgba(120, 80, 40, 0.18);
  --pl-color-toolbar-btn-hover: rgba(0, 0, 0, 0.05);
  --pl-color-toolbar-btn-avatar-bg: rgba(0, 0, 0, 0.10);
  --pl-color-toolbar-shadow: rgba(120, 90, 60, 0.20);

  /* Mini widget — light warm cream gradient. */
  --pl-mini-bg-stop-1: #faf7f2;
  --pl-mini-bg-stop-2: #ede5d4;
  --pl-mini-bg-stop-3: #d4c8b3;
  --pl-mini-bg-edge-top: rgba(0, 0, 0, 0.06);
  --pl-mini-bg-edge-bottom: rgba(0, 0, 0, 0.14);
  --pl-mini-fg: #292524;
  --pl-mini-bg-glow: radial-gradient(ellipse 75% 75% at 30% 28%, rgba(15, 98, 254, 0.16) 0%, rgba(15, 98, 254, 0) 60%);
  --pl-mini-accent: #0f62fe;
  --pl-mini-accent-soft: rgba(15, 98, 254, 0.18);
  --pl-mini-stroke: rgba(0, 0, 0, 0.10);
  --pl-mini-shadow:
    0 18px 36px -12px rgba(120, 80, 40, 0.32),
    0 4px 12px -4px rgba(120, 80, 40, 0.20),
    inset 0 1px 0 rgba(255, 255, 255, 0.65),
    inset 0 -1px 0 rgba(0, 0, 0, 0.10);
  --pl-mini-icon-shadow: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.15));
  --pl-mini-btn-hover-bg: rgba(0, 0, 0, 0.06);
  --pl-mini-btn-active-bg: linear-gradient(135deg, rgba(15, 98, 254, 0.24) 0%, rgba(15, 98, 254, 0.06) 100%);

  /* Wordmark on light surface — "live" reads as a mid-gray at rest
     (matched ~45% perceived brightness to the dark-bg themes),
     "docs" in blue. The hover overrides flip the live token to a
     darker shade so it stays visible on the cream surface (the
     default dark-bg recipes use white hover which would vanish here). */
  --pl-mini-logo-fg-live: rgba(0, 0, 0, 0.50);
  --pl-mini-logo-fg-docs: rgba(15, 98, 254, 0.88);
  --pl-mini-logo-shadow-live: 0 1px 0 rgba(255, 255, 255, 0.55);
  --pl-mini-logo-shadow-docs: 0 0 5px rgba(15, 98, 254, 0.20), 0 1px 0 rgba(255, 255, 255, 0.35);
  --pl-mini-logo-fg-live-hover: rgba(0, 0, 0, 0.82);
  --pl-mini-logo-shadow-live-hover: 0 1px 0 rgba(255, 255, 255, 0.55);
  --pl-mini-logo-hover-glow-docs: 0 0 12px rgba(15, 98, 254, 0.45), 0 1px 0 rgba(255, 255, 255, 0.35);

  /* Sharp corners + squarer chrome — keep the brutalist geometry. */
  --pl-mini-corner-radius-x: 22px;
  --pl-mini-corner-radius-y: 22px;
  --pl-radius-sm: 2px;
  --pl-radius-md: 3px;
  --pl-radius-lg: 4px;

}
/* Sidebar — warm cream chrome to match the cream mini widget + toolbar,
   warm-dark text. */
[data-pl-theme="light"] .pl-sidebar {
  --pl-color-surface: #f1ebe1;
  --pl-color-surface-muted: #ede5d4;
  --pl-color-surface-sunken: #e8dfd0;
  --pl-color-text: #292524;
  --pl-color-text-muted: #57534e;
  --pl-color-text-soft: #78716c;
  --pl-color-text-faint: #a8a29e;
  --pl-color-border: #d4c8b3;
  --pl-color-border-strong: #b8a88a;
  /* Selected comment — a deeper tan, warm rather than the default blue tint. */
  --pl-color-primary-subtle-bg: #e2d4bd;
}`
  },
  "minimal-neutral": {
    base: "dark",
    css: `[data-pl-theme="dark"] {
  /* Surface — pure neutral ramp. */
  --pl-color-surface: #0a0a0a;
  --pl-color-surface-muted: #161616;
  --pl-color-surface-sunken: #1f1f1f;
  --pl-color-border: #262626;
  --pl-color-border-strong: #3f3f46;
  --pl-color-border-subtle: #1a1a1a;

  --pl-color-text: #f5f5f5;
  --pl-color-text-muted: #d4d4d4;
  --pl-color-text-soft: #a1a1aa;
  --pl-color-text-faint: #71717a;

  /* Brand — neutral first, emerald accent only on truly important hits. */
  --pl-color-primary: #34d399;
  --pl-color-primary-hover: #6ee7b7;
  --pl-color-primary-soft: #064e3b;
  --pl-color-primary-soft-border: #10b981;
  --pl-color-primary-subtle-bg: #022c22;

  /* Focus ring */
  --pl-focus-ring: 0 0 0 2px rgba(52, 211, 153, 0.45);

  /* Shadows — sharper / darker for the deep neutral surface. */
  --pl-shadow-sidebar: -2px 0 12px rgba(0, 0, 0, 0.6);
  --pl-shadow-popover: 0 8px 24px rgba(0, 0, 0, 0.65);
  --pl-shadow-popover-sm: 0 4px 12px rgba(0, 0, 0, 0.55);

  /* Comment tooltip — neutral, accent emerald. */
  --pl-ctooltip-bg: rgba(8, 8, 8, 0.96);
  --pl-ctooltip-stroke: rgba(255, 255, 255, 0.10);
  --pl-ctooltip-accent: #34d399;
  --pl-ctooltip-avatar-bg: linear-gradient(135deg, #34d399 0%, #047857 100%);

  /* Bubble — neutral gray with emerald flash + anchor highlight. */
  --pl-bubble-base: #3f3f46;
  --pl-bubble-bg: linear-gradient(135deg, var(--pl-bubble-base) 0%, #18181b 100%);
  --pl-bubble-ring: rgba(63, 63, 70, 0.55);
  --pl-bubble-glow: 0 6px 18px -6px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(255, 255, 255, 0.06);
  --pl-bubble-flash: rgba(52, 211, 153, 0.55);
  --pl-bubble-flash-bg: rgba(52, 211, 153, 0.45);
  --pl-bubble-flash-bg-trans: rgba(52, 211, 153, 0);
  --pl-bubble-anchor-highlight: rgba(52, 211, 153, 0.18);
  --pl-bubble-soft-glow: rgba(52, 211, 153, 0.40);

  /* Toolbar — true neutral black. */
  --pl-color-toolbar-bg: #050505;
  --pl-color-toolbar-fg: #f5f5f5;
  --pl-color-toolbar-btn-border: rgba(255, 255, 255, 0.15);
  --pl-color-toolbar-btn-hover: rgba(255, 255, 255, 0.06);
  --pl-color-toolbar-shadow: rgba(0, 0, 0, 0.5);

  /* Mini widget — neutral with emerald accent. */
  --pl-mini-bg-stop-1: #27272a;
  --pl-mini-bg-stop-2: #18181b;
  --pl-mini-bg-stop-3: #09090b;
  --pl-mini-accent: #34d399;
  --pl-mini-accent-soft: rgba(52, 211, 153, 0.18);
  --pl-mini-bg-glow: radial-gradient(ellipse 75% 75% at 30% 28%, rgba(52, 211, 153, 0.18) 0%, rgba(52, 211, 153, 0) 60%);
  --pl-mini-btn-active-bg: linear-gradient(135deg, rgba(52, 211, 153, 0.28) 0%, rgba(52, 211, 153, 0.08) 100%);

  /* Wordmark — emerald "docs", no glow. */
  --pl-mini-logo-fg-docs: rgba(52, 211, 153, 0.85);
  --pl-mini-logo-shadow-docs: 0 1px 0 rgba(0, 0, 0, 0.35);
  --pl-mini-logo-hover-glow-docs: 0 0 8px rgba(52, 211, 153, 0.45), 0 1px 0 rgba(0, 0, 0, 0.42);

}
/* Sidebar — neutral zinc chrome matching the mini widget (a touch lighter
   than the near-black surface so the panel reads as chrome). */
[data-pl-theme="dark"] .pl-sidebar {
  --pl-color-surface: #18181b;
  --pl-color-surface-muted: #1f1f22;
  --pl-color-surface-sunken: #232327;
  --pl-color-text: #f5f5f5;
  --pl-color-text-muted: #d4d4d4;
  --pl-color-text-soft: #a1a1aa;
  --pl-color-text-faint: #71717a;
  --pl-color-border: #2e2e35;
  --pl-color-border-strong: #3f3f46;
  /* Selected comment — a lighter zinc than the panel; emerald accent untouched. */
  --pl-color-primary-subtle-bg: #2e2e35;
}`
  }
};
function zt() {
  return [{
    id: "",
    label: "Default (project theme)"
  }, ...Fe.map((e) => ({
    id: e.id,
    label: e.label
  }))];
}
function Wt(e, t) {
  if (!e) return {
    base: t,
    overlayCss: null
  };
  if (jt.has(e)) return {
    base: e,
    overlayCss: null
  };
  const s = Ut[e];
  return s ? {
    base: s.base,
    overlayCss: s.css
  } : {
    base: t,
    overlayCss: null
  };
}
function pe(e) {
  const t = "pl-theme-overlay";
  let s = document.getElementById(t);
  if (!e) {
    s && (s.textContent = "");
    return;
  }
  s || (s = document.createElement("style"), s.id = t, document.head.appendChild(s)), s.textContent !== e && (s.textContent = e);
}
function G(e, t) {
  return `${e.api.getEndpoint().replace(/\/$/, "")}/admin${t.startsWith("/") ? t : `/${t}`}`;
}
function Kt(e, t) {
  const s = G(e, t), o = e.api.getToken();
  return o ? `${s}#pl_token=${encodeURIComponent(o)}` : s;
}
function ee(e, t) {
  window.open(Kt(e, t), "_blank", "noopener");
}
var Vt = "#3b82f6";
function he(e) {
  return e.length === 0 ? e : e[0].toUpperCase() + e.slice(1);
}
function ue(e) {
  if (!e.notifications || typeof Notification > "u") return "";
  const t = Notification.permission;
  let s = "";
  return t === "granted" ? s = '<span class="pl-config-menu__notif-state pl-config-menu__notif-state--on">On</span>' : t === "denied" ? s = `<span class="pl-config-menu__notif-state pl-config-menu__notif-state--off" data-pl-tip="Flip in your browser's site permissions to re-enable">Blocked</span>` : s = '<button type="button" class="pl-config-menu__notif-cta" data-notif-enable="1">Enable</button>', `
      <label class="pl-config-menu__row pl-config-menu__row--notif">
        <span>Browser notifications</span>
        ${s}
      </label>`;
}
function me(e, t) {
  return e.widgetModeOverride ?? t;
}
function Yt(e) {
  return {
    "lower-right": "Lower Right",
    "lower-left": "Lower Left",
    "upper-right": "Upper Right",
    "upper-left": "Upper Left"
  }[e];
}
function te(e, t) {
  const s = t.get(), o = e.ui(), i = o.toolbarPosition ?? "top", a = o.sidebarPosition ?? o.sidebarSide ?? "right", n = o.widgetMode ?? "docked", l = o.widgetCorner ?? "lower-right", d = s.theme ?? "", c = zt(), p = (f, C) => {
    const L = s[f];
    return `
      <label class="pl-config-menu__row pl-config-menu__row--select">
        <span>${C}</span>
        <select data-setting-size="${f}">${[
      1,
      2,
      3,
      4,
      5
    ].map(($) => `<option value="${$}" ${L === $ ? "selected" : ""}>${ot[$]}</option>`).join("")}</select>
      </label>`;
  }, m = e.user() !== null, h = e.bubbleColor() ?? Vt, b = m ? `
      <label class="pl-config-menu__row pl-config-menu__row--color">
        <span>Bubble color</span>
        <input type="color" data-setting-bubble-color value="${h}" aria-label="Bubble color">
      </label>` : "", u = document.createElement("div");
  u.className = "pl-config-menu";
  const v = s.toolbarPositionOverride ?? "", E = s.sidebarPositionOverride ?? "", g = s.widgetModeOverride ?? "", y = s.widgetCornerOverride ?? "", x = me(s, n);
  u.innerHTML = `
      <div class="pl-config-menu__title pl-config-menu__title--with-action">
        <span>Settings</span>
        <a class="pl-config-menu__viewall" href="#" data-action="view-all" data-pl-tip="Open your full settings in the admin">View all${_("external-link", "pl-config-menu__viewall-ext")}</a>
      </div>
      <label class="pl-config-menu__row pl-config-menu__row--select">
        <span>Mode</span>
        <select data-setting-override="widgetModeOverride">
          <option value=""       ${g === "" ? "selected" : ""}>Default (${n === "mini" ? "Mini bubble" : "Docked toolbar"})</option>
          <option value="docked" ${g === "docked" ? "selected" : ""}>Docked toolbar</option>
          <option value="mini"   ${g === "mini" ? "selected" : ""}>Mini bubble</option>
        </select>
      </label>
      <label class="pl-config-menu__row pl-config-menu__row--select" data-mode-row="docked" ${x === "docked" ? "" : "hidden"}>
        <span>Toolbar position</span>
        <select data-setting-override="toolbarPositionOverride">
          <option value=""       ${v === "" ? "selected" : ""}>Default (${i})</option>
          <option value="top"    ${v === "top" ? "selected" : ""}>Top</option>
          <option value="bottom" ${v === "bottom" ? "selected" : ""}>Bottom</option>
        </select>
      </label>
      <label class="pl-config-menu__row pl-config-menu__row--select" data-mode-row="mini" ${x === "mini" ? "" : "hidden"}>
        <span>Widget corner</span>
        <select data-setting-override="widgetCornerOverride">
          <option value=""             ${y === "" ? "selected" : ""}>Default (${Yt(l)})</option>
          <option value="lower-right"  ${y === "lower-right" ? "selected" : ""}>Lower Right</option>
          <option value="lower-left"   ${y === "lower-left" ? "selected" : ""}>Lower Left</option>
          <option value="upper-right"  ${y === "upper-right" ? "selected" : ""}>Upper Right</option>
          <option value="upper-left"   ${y === "upper-left" ? "selected" : ""}>Upper Left</option>
        </select>
      </label>
      <label class="pl-config-menu__row pl-config-menu__row--select">
        <span>Sidebar side</span>
        <select data-setting-override="sidebarPositionOverride">
          <option value=""       ${E === "" ? "selected" : ""}>${he(a)} (default)</option>
          ${[
    "left",
    "right",
    "top",
    "bottom"
  ].filter((f) => f !== a).map((f) => `<option value="${f}" ${E === f ? "selected" : ""}>${he(f)}</option>`).join(`
          `)}
        </select>
      </label>
      <label class="pl-config-menu__row">
        <input type="checkbox" data-setting="showReplyCountInBubbles" ${s.showReplyCountInBubbles ? "checked" : ""}>
        <span>Show replies in bubbles</span>
      </label>
      <label class="pl-config-menu__row pl-config-menu__row--select">
        <span>Theme</span>
        <select data-setting-override="theme">
          ${c.map((f) => {
    const C = d === f.id ? "selected" : "";
    return `<option value="${f.id}" ${C}>${f.label}</option>`;
  }).join(`
          `)}
        </select>
      </label>
      <label class="pl-config-menu__row pl-config-menu__row--select">
        <span>Comment spacing</span>
        <select data-setting="commentSpacing">
          <option value="none"     ${s.commentSpacing === "none" ? "selected" : ""}>None</option>
          <option value="minimal"  ${s.commentSpacing === "minimal" ? "selected" : ""}>Minimal</option>
          <option value="relaxed"  ${s.commentSpacing === "relaxed" ? "selected" : ""}>Relaxed</option>
          <option value="spacious" ${s.commentSpacing === "spacious" ? "selected" : ""}>Spacious</option>
        </select>
      </label>
      ${p("bubbleSize", "Bubble size")}
      ${p("textSize", "Text size")}
      ${b}
      ${ue(e)}
    `, u.querySelector('[data-action="view-all"]')?.addEventListener("click", (f) => {
    f.preventDefault(), ee(e, "/settings");
  }), u.querySelectorAll("input[data-setting]").forEach((f) => {
    f.addEventListener("change", () => {
      t.update({ [f.dataset.setting]: f.checked });
    });
  }), u.querySelectorAll("select[data-setting]").forEach((f) => {
    f.addEventListener("change", () => {
      t.update({ [f.dataset.setting]: f.value });
    });
  }), u.querySelectorAll("select[data-setting-override]").forEach((f) => {
    f.addEventListener("change", () => {
      const C = f.dataset.settingOverride, L = f.value === "" ? void 0 : f.value;
      if (t.update({ [C]: L }), C === "widgetModeOverride") {
        const $ = me(t.get(), n);
        u.querySelectorAll("[data-mode-row]").forEach((A) => {
          A.hidden = A.dataset.modeRow !== $;
        });
      }
    });
  }), u.querySelectorAll("select[data-setting-size]").forEach((f) => {
    f.addEventListener("change", () => {
      const C = f.dataset.settingSize, L = Number(f.value);
      t.update({ [C]: L });
    });
  });
  const P = u.querySelector("input[data-setting-bubble-color]");
  P && (P.addEventListener("input", () => {
    e.bus.emit("bubbles:recolor", { color: P.value });
  }), P.addEventListener("change", () => {
    const f = P.value;
    e.bus.emit("bubbles:recolor", { color: f }), e.api.call("me.settings.update", {
      groupId: "appearance",
      patch: { bubbleColor: f }
    }).catch(() => {
      e.bus.emit("toast:show", {
        kind: "error",
        message: "Could not save your bubble colour."
      });
    });
  }));
  const k = u.querySelector("button[data-notif-enable]");
  return k && e.notifications && k.addEventListener("click", async (f) => {
    f.preventDefault(), k.disabled = !0, k.textContent = "Requesting…";
    const C = await e.notifications.requestPermission(), L = k.closest(".pl-config-menu__row");
    if (L) {
      const $ = document.createElement("div");
      $.innerHTML = ue(e).trim();
      const A = $.firstElementChild;
      A && L.replaceWith(A);
    }
    e.bus.emit("toast:show", {
      kind: C === "granted" ? "success" : "info",
      message: C === "granted" ? "Browser notifications enabled." : C === "denied" ? "Notifications blocked. Flip it in your browser's site permissions to re-enable." : "Notification prompt dismissed."
    });
  }), u;
}
function Ae(e, t) {
  const s = t.project().id, o = t.api.getEndpoint(), i = window.location.href.split("#")[0] ?? window.location.href, a = (() => {
    try {
      return new URL(o).origin;
    } catch {
      return "";
    }
  })() === window.location.origin, n = t.ui().signInMode, l = n === "popup" || n !== "redirect" && !a, d = new URLSearchParams({
    projectId: s,
    redirect: i
  });
  l && d.set("popup", "1");
  const c = `${o}/api/v1/auth/${e}/start?${d.toString()}`;
  l ? Gt(c, o, t) : window.location.href = c;
}
function Gt(e, t, s) {
  const a = Math.max(0, Math.floor(window.screenX + (window.outerWidth - 480) / 2)), n = Math.max(0, Math.floor(window.screenY + (window.outerHeight - 640) / 2)), l = window.open(e, "pl-oauth", `width=480,height=640,left=${a},top=${n},resizable=yes,scrollbars=yes`);
  if (!l) {
    window.location.href = e;
    return;
  }
  const d = new URL(t).origin;
  let c = !1, p;
  const m = () => {
    window.removeEventListener("message", h), p && clearInterval(p);
  }, h = (b) => {
    if (b.origin !== d) return;
    const u = b.data;
    if (!(!u || u.type !== "pageloop:auth" || !u.token)) {
      c = !0, m();
      try {
        localStorage.setItem(_e, u.token);
      } catch {
      }
      s.api.setToken(u.token), window.location.reload();
    }
  };
  window.addEventListener("message", h), p = setInterval(() => {
    l.closed && (clearInterval(p), !c && (m(), console.error("[pageloop] Sign-in popup closed without returning a session. If you did complete the provider prompt, the host page is likely sending `Cross-Origin-Opener-Policy: same-origin`, which severs the popup's opener reference. Set it to `same-origin-allow-popups` (or unset it) on the page that embeds the PageLoop widget.")));
  }, 500);
}
function Xt(e) {
  try {
    localStorage.removeItem(_e);
    const t = [];
    for (let s = 0; s < localStorage.length; s++) {
      const o = localStorage.key(s);
      o && o.startsWith("pl_widget_user:") && t.push(o);
    }
    for (const s of t) localStorage.removeItem(s);
  } catch {
  }
  e.api.setToken(null), window.location.reload();
}
function se(e, t = {}) {
  const s = e.user(), o = document.createElement("div");
  if (o.className = "pl-config-menu pl-auth-menu", s) {
    const i = (s.displayName ?? s.email).trim();
    o.innerHTML = `
      <button type="button" class="pl-config-menu__title pl-auth-menu__title pl-auth-menu__profile" data-action="profile" data-pl-tip="Open your profile in the admin">
        <span class="pl-auth-menu__avatar">${w(q(i))}</span>
        <span class="pl-auth-menu__identity">
          <span class="pl-auth-menu__name">${w(i)}</span>
          ${s.email && s.email !== i ? `<span class="pl-auth-menu__email">${w(s.email)}</span>` : ""}
        </span>
        ${_("external-link", "pl-auth-menu__ext")}
      </button>
      <button type="button" class="pl-config-menu__row pl-auth-row" data-action="sign-out">
        <span>Sign out</span>
      </button>
    `, o.querySelector('[data-action="profile"]').addEventListener("click", () => {
      t.onAction?.(), ee(e, "/profile");
    }), o.querySelector('[data-action="sign-out"]').addEventListener("click", () => {
      t.onAction?.(), Xt(e);
    });
  } else
    o.innerHTML = `
      <div class="pl-config-menu__title">Sign in</div>
      <button type="button" class="pl-config-menu__row pl-auth-row" data-provider="google">
        <span>Sign in with Google</span>
      </button>
      <button type="button" class="pl-config-menu__row pl-auth-row" data-provider="github">
        <span>Sign in with GitHub</span>
      </button>
    `, o.querySelectorAll("[data-provider]").forEach((i) => {
      i.addEventListener("click", () => {
        t.onAction?.(), Ae(i.dataset.provider, e);
      });
    });
  return o;
}
var Jt = 1e3, N = null;
function Zt(e) {
  return N || (N = (async () => {
    try {
      const t = await fetch(`${e}/api/v1/auth/config`, { method: "GET" });
      if (!t.ok) return {
        localAuth: !0,
        allowUserSignups: !1,
        google: null
      };
      const s = await t.json();
      return {
        localAuth: s.localAuth !== !1,
        allowUserSignups: s.allowUserSignups === !0,
        google: s.google ?? null
      };
    } catch {
      return {
        localAuth: !0,
        allowUserSignups: !1,
        google: null
      };
    }
  })(), N);
}
var D = null;
function oe(e, t = {}) {
  D?.close();
  const s = e.api.getEndpoint(), o = document.createElement("div");
  o.className = "pl-auth-modal-overlay";
  const i = document.createElement("div");
  i.className = "pl-auth-modal", i.setAttribute("role", "dialog"), i.setAttribute("aria-modal", "true"), i.setAttribute("aria-label", "Sign in"), o.appendChild(i), document.body.appendChild(o);
  let a = t.view === "register" ? "register" : "signin", n = null, l = !1, d = null;
  const c = (g) => {
    if (g.key === "Escape") {
      h();
      return;
    }
    g.key === "Tab" && p(g);
  };
  function p(g) {
    const y = Array.from(i.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter((f) => !f.hasAttribute("disabled") && f.offsetParent !== null);
    if (y.length === 0) return;
    const x = y[0], P = y[y.length - 1], k = document.activeElement;
    k && !i.contains(k) ? (g.preventDefault(), x.focus()) : g.shiftKey && k === x ? (g.preventDefault(), P.focus()) : !g.shiftKey && k === P && (g.preventDefault(), x.focus());
  }
  function m() {
    i.querySelector("input:not([disabled]), .pl-auth-modal__submit, .pl-auth-modal__sso")?.focus();
  }
  function h() {
    d && (clearTimeout(d), d = null), o.remove(), document.removeEventListener("keydown", c), D?.close === h && (D = null);
  }
  function b(g) {
    i.innerHTML = `
      <div class="pl-auth-modal__success" role="status">
        <div class="pl-auth-modal__success-icon" aria-hidden="true">${_("check")}</div>
        <p class="pl-auth-modal__success-msg">${w(g)}</p>
      </div>`, d && clearTimeout(d), d = setTimeout(h, Jt);
  }
  D = { close: h }, document.addEventListener("keydown", c), o.addEventListener("mousedown", (g) => {
    g.target === o && h();
  });
  function u() {
    const g = [];
    return (!n || n.google) && g.push('<button type="button" class="pl-auth-modal__sso" data-provider="google">Continue with Google</button>'), g.push('<button type="button" class="pl-auth-modal__sso" data-provider="github">Continue with GitHub</button>'), g.join("");
  }
  function v() {
    if (!n) {
      i.innerHTML = '<div class="pl-auth-modal__loading">Loading…</div>';
      return;
    }
    const g = a === "register", y = n.localAuth, x = n.localAuth && n.allowUserSignups, P = g ? "Create your account" : "Sign in", k = S.getItem(Ue), f = k ? `<p class="pl-auth-modal__org">${w(k)}</p>` : "", C = y ? `
        <form class="pl-auth-modal__form" novalidate>
          ${g ? '<input class="pl-auth-modal__input" type="text" name="name" placeholder="Name (optional)" autocomplete="name">' : ""}
          <input class="pl-auth-modal__input" type="email" name="email" placeholder="Email" autocomplete="email" required>
          <input class="pl-auth-modal__input" type="password" name="password" placeholder="Password" autocomplete="${g ? "new-password" : "current-password"}" required>
          <div class="pl-auth-modal__error" hidden role="alert"></div>
          <button type="submit" class="pl-auth-modal__submit">${g ? "Create account" : "Sign in"}</button>
        </form>
        <div class="pl-auth-modal__divider" aria-hidden="true"><span>or</span></div>` : "", L = x ? g ? '<p class="pl-auth-modal__alt">Already have an account? <button type="button" class="pl-auth-modal__link" data-view="signin">Sign in</button></p>' : `<p class="pl-auth-modal__alt">Don't have an account? <button type="button" class="pl-auth-modal__link" data-view="register">Create account</button></p>` : "";
    i.innerHTML = `
      <button type="button" class="pl-auth-modal__close" aria-label="Close">&times;</button>
      <div class="pl-auth-modal__brand" aria-label="${M.nameTitle}"><span class="pl-auth-modal__logo-head">${M.wordmark.head}</span><span class="pl-auth-modal__logo-tail">${M.wordmark.tail}</span></div>
      <h2 class="pl-auth-modal__title">${P}</h2>
      ${f}
      ${C}
      <div class="pl-auth-modal__sso-group">${u()}</div>
      ${L}
    `, E(), m();
  }
  function E() {
    i.querySelector(".pl-auth-modal__close")?.addEventListener("click", () => h()), i.querySelectorAll("[data-provider]").forEach((k) => {
      k.addEventListener("click", () => Ae(k.dataset.provider, e));
    }), i.querySelectorAll("[data-view]").forEach((k) => {
      k.addEventListener("click", () => {
        a = k.dataset.view === "register" ? "register" : "signin", v();
      });
    });
    const g = i.querySelector(".pl-auth-modal__form");
    if (!g) return;
    const y = i.querySelector(".pl-auth-modal__error"), x = i.querySelector(".pl-auth-modal__submit"), P = (k) => {
      y.textContent = k, y.hidden = !1;
    };
    g.addEventListener("submit", async (k) => {
      if (k.preventDefault(), l) return;
      const f = new FormData(g), C = String(f.get("email") ?? "").trim(), L = String(f.get("password") ?? ""), $ = String(f.get("name") ?? "").trim();
      if (y.hidden = !0, y.textContent = "", !C || !L) {
        P("Enter your email and password.");
        return;
      }
      const A = a === "register";
      l = !0, x.disabled = !0, x.textContent = A ? "Creating…" : "Signing in…";
      try {
        const H = A ? await e.api.call("auth.register", {
          email: C,
          password: L,
          displayName: $ || void 0
        }) : await e.api.call("auth.login", {
          email: C,
          password: L
        });
        b(A ? "Account created!" : "Logged in!"), e.applyToken(H.token).catch(() => {
        });
      } catch (H) {
        P(Qt(H, A)), l = !1, x.disabled = !1, x.textContent = A ? "Create account" : "Sign in";
      }
    });
  }
  v(), Zt(s).then((g) => {
    n = g, a === "register" && !(g.localAuth && g.allowUserSignups) && (a = "signin"), v();
  });
}
function Qt(e, t) {
  const s = (e instanceof Error ? e.message : String(e)).replace(/^[A-Z_]+:\s*/, "").trim();
  return s || (t ? "Could not create your account." : "Could not sign you in.");
}
var be = "pl_whatsnew_seen_v1";
function es(e, t) {
  const s = e.split(/[.+-]/).map((a) => parseInt(a, 10)), o = t.split(/[.+-]/).map((a) => parseInt(a, 10)), i = Math.max(s.length, o.length);
  for (let a = 0; a < i; a++) {
    const n = Number.isFinite(s[a]) ? s[a] : 0, l = Number.isFinite(o[a]) ? o[a] : 0;
    if (n !== l) return n - l;
  }
  return 0;
}
var ge = class {
  constructor(e, t, s) {
    r(this, "deps", void 0), r(this, "settings", void 0), r(this, "actions", void 0), r(this, "handle", void 0), r(this, "root", void 0), r(this, "connEl", void 0), r(this, "bubblesBtn", void 0), r(this, "configBtn", void 0), r(this, "authSlot", void 0), r(this, "adminBtn", void 0), r(this, "configPopover", new I()), r(this, "authPopover", new I()), r(this, "adminPopover", new I()), this.deps = e, this.settings = t, this.actions = s, this.root = document.createElement("div"), this.root.className = "pl-toolbar", this.root.innerHTML = `
      <span class="pl-toolbar__title"><span class="pl-toolbar__title-head">${M.wordmark.head}</span><span class="pl-toolbar__title-tail">${M.wordmark.tail}</span></span>
      <button type="button" class="pl-conn pl-conn--offline" data-action="conn" aria-label="Connection: offline. Click to retry." title="Offline — click to retry">offline</button>
      <span class="pl-toolbar__version" data-pl-tip="@pageloop/vanilla@${U}">v${U}</span>
      <span class="pl-toolbar__spacer"></span>
      <span class="pl-toolbar__auth"></span>
      <button class="pl-btn" data-action="picker">Pick element</button>
      <button class="pl-btn" data-action="bubbles" data-active="true" aria-pressed="true" data-pl-tip="Toggle comment bubbles (b)">Bubbles</button>
      <button class="pl-btn" data-action="comments" data-active="false" aria-pressed="false">Comments</button>
      <button class="pl-btn" data-action="admin" data-pl-tip="Admin actions" hidden>Admin</button>
      <button class="pl-btn pl-toolbar__config-btn" data-action="config" data-pl-tip="Settings" aria-label="Settings">${_("settings")}</button>
      <button class="pl-btn pl-toolbar__dismiss" data-action="dismiss" data-pl-tip="Hide PageLoop (until reload)" aria-label="Hide PageLoop until reload">${_("close")}</button>
    `, document.body.prepend(this.root), this.connEl = this.root.querySelector(".pl-conn"), this.connEl.addEventListener("click", () => {
      this.connEl.classList.contains("pl-conn--offline") && (this.setReconnecting(), e.api.retryNow());
    }), this.bubblesBtn = this.root.querySelector('[data-action="bubbles"]'), this.configBtn = this.root.querySelector('[data-action="config"]'), this.authSlot = this.root.querySelector(".pl-toolbar__auth"), this.adminBtn = this.root.querySelector('[data-action="admin"]'), this.root.querySelector('[data-action="comments"]').addEventListener("click", s.toggleSidebar), this.root.querySelector('[data-action="picker"]').addEventListener("click", s.togglePicker), this.bubblesBtn.addEventListener("click", s.toggleBubbles), this.root.querySelector('[data-action="dismiss"]').addEventListener("click", () => this.deps.dismiss()), this.configBtn.addEventListener("click", (n) => {
      n.stopPropagation(), this.toggleConfigMenu();
    });
    const o = () => {
      const n = e.role();
      this.adminBtn.hidden = n !== "editor" && n !== "owner";
    };
    o(), e.bus.on("page:change", o), this.adminBtn.addEventListener("click", (n) => {
      n.stopPropagation(), this.toggleAdminMenu();
    }), this.renderAuthSlot(), e.bus.on("page:change", () => this.renderAuthSlot()), e.bus.on("auth:changed", () => this.renderAuthSlot());
    const i = this.root.querySelector('[data-action="comments"]');
    e.bus.on("sidebar:toggle", (n) => {
      const l = !!n?.open;
      i.dataset.active = String(l), i.setAttribute("aria-pressed", String(l));
    });
    const a = S.getItem("pl_bubbles_hidden") === "1";
    this.bubblesBtn.dataset.active = String(!a), this.bubblesBtn.setAttribute("aria-pressed", String(!a)), e.bus.on("bubbles:toggle", (n) => {
      const l = !!n?.visible;
      this.bubblesBtn.dataset.active = String(l), this.bubblesBtn.setAttribute("aria-pressed", String(l));
    }), document.addEventListener("keydown", (n) => {
      n.key === "b" && !n.metaKey && !n.ctrlKey && !n.altKey && !We(n.target) && (n.preventDefault(), s.toggleBubbles());
    }), this.handle = {
      setUnreadCount: () => {
      },
      setBubblesVisible: (n) => {
        this.bubblesBtn.dataset.active = String(n), this.bubblesBtn.setAttribute("aria-pressed", String(n));
      }
    }, this.maybeShowWhatsNew();
  }
  maybeShowWhatsNew() {
    const { version: e, notesUrl: t } = this.deps.release();
    if (!e) return;
    const s = S.getItem(be);
    if (s && es(e, s) <= 0) return;
    const o = document.createElement("div");
    o.className = "pl-whatsnew";
    const i = `Updated to v${e}`, a = () => S.setItem(be, e);
    if (t) {
      o.innerHTML = `<a class="pl-whatsnew__link" target="_blank" rel="noopener noreferrer">${w(i)} →</a><button type="button" class="pl-whatsnew__close" aria-label="Dismiss">${_("close")}</button>`;
      const n = o.querySelector(".pl-whatsnew__link");
      n.href = t, n.addEventListener("click", () => {
        a(), o.remove();
      });
    } else o.innerHTML = `<span class="pl-whatsnew__link">${w(i)}</span><button type="button" class="pl-whatsnew__close" aria-label="Dismiss">${_("close")}</button>`;
    o.querySelector(".pl-whatsnew__close").addEventListener("click", () => {
      a(), o.remove();
    }), this.root.querySelector(".pl-toolbar__version")?.insertAdjacentElement("afterend", o);
  }
  setConnection(e) {
    this.connEl.classList.remove("pl-conn--reconnecting"), e ? (this.connEl.textContent = e, this.connEl.classList.remove("pl-conn--offline"), this.connEl.setAttribute("aria-label", `Connection: ${e}`), this.connEl.title = `Connected (${e})`) : (this.connEl.textContent = "offline", this.connEl.classList.add("pl-conn--offline"), this.connEl.setAttribute("aria-label", "Connection: offline. Click to retry."), this.connEl.title = "Offline — click to retry");
  }
  setReconnecting() {
    this.connEl.textContent = "reconnecting", this.connEl.classList.remove("pl-conn--offline"), this.connEl.classList.add("pl-conn--reconnecting"), this.connEl.setAttribute("aria-label", "Connection: reconnecting"), this.connEl.title = "Reconnecting…";
  }
  setHidden(e) {
    this.root.classList.toggle("pl-toolbar--hidden", e), e && (this.configPopover.close(), this.authPopover.close(), this.adminPopover.close());
  }
  toggleConfigMenu() {
    if (this.configPopover.isOpen()) {
      this.configPopover.close();
      return;
    }
    const e = te(this.deps, this.settings);
    this.configPopover.open(e, this.configBtn);
  }
  renderAuthSlot() {
    const e = this.deps.user();
    if (e) {
      const t = (e.displayName ?? e.email).trim(), s = q(t);
      this.authSlot.innerHTML = `
        <button class="pl-btn pl-toolbar__user" data-action="user-menu" data-pl-tip="${w(t)}">
          <span class="pl-toolbar__avatar">${w(s)}</span>
          <span class="pl-toolbar__user-name">${w(t)}</span>
        </button>
      `, this.authSlot.querySelector('[data-action="user-menu"]').addEventListener("click", (o) => {
        o.stopPropagation(), this.toggleUserMenu();
      });
    } else
      this.authSlot.innerHTML = '<button class="pl-btn" data-action="sign-in">Sign in</button>', this.authSlot.querySelector('[data-action="sign-in"]').addEventListener("click", (t) => {
        t.stopPropagation(), oe(this.deps);
      });
  }
  toggleUserMenu() {
    if (this.authPopover.isOpen()) {
      this.authPopover.close();
      return;
    }
    if (!this.deps.user()) return;
    const e = se(this.deps, { onAction: () => this.authPopover.close() });
    this.authPopover.open(e, this.authSlot.querySelector("button"));
  }
  async toggleAdminMenu() {
    if (this.adminPopover.isOpen()) {
      this.adminPopover.close();
      return;
    }
    const e = document.createElement("div");
    e.className = "pl-config-menu pl-admin-menu";
    const t = this.deps.project(), s = this.deps.role() === "owner", o = this.deps.page(), i = !!o?.manuallyAdded, a = o?.key ?? this.deps.pageKey();
    e.innerHTML = `<div class="pl-config-menu__title">Admin · ${w(t.slug)}</div>
      <div class="pl-admin-menu__section">
        <div class="pl-admin-menu__section-head">Project</div>
        <div class="pl-admin-project">
          <label class="pl-admin-project__label" for="pl-admin-name">Name</label>
          <div class="pl-admin-project__row">
            <input id="pl-admin-name" class="pl-admin-project__input" type="text" maxlength="120" value="${w(t.name)}" ${s ? "" : "disabled"}>
            <button class="pl-btn pl-btn--mini pl-btn--primary" data-action="rename-save" type="button" ${s ? "" : "disabled"}>Save</button>
          </div>
          <div class="pl-admin-project__hint">Slug <code>${w(t.slug)}</code> can't be changed — it's the public identifier.${s ? "" : " Only the project owner can rename."}</div>
          <div class="pl-admin-project__status" hidden></div>
        </div>
      </div>
      <div class="pl-admin-menu__section">
        <div class="pl-admin-menu__section-head">This page</div>
        <div class="pl-admin-project">
          <div class="pl-admin-project__hint" style="margin-bottom:6px;">Index this page in the dashboard so members can find + sort it without commenting first. Idempotent — clicking again is a no-op.</div>
          <div class="pl-admin-project__row">
            <button class="pl-btn pl-btn--mini ${i ? "" : "pl-btn--primary"}" data-action="track-page" type="button" ${i ? "disabled" : ""}>
              ${i ? "✓ Tracked" : "Track this page"}
            </button>
            <code class="pl-admin-project__input" style="background:transparent;border:none;padding:0;font-size:11px;opacity:0.7;">${w(a)}</code>
          </div>
          <div class="pl-admin-project__status" data-status="track-page" hidden></div>
        </div>
      </div>
      <div class="pl-admin-menu__section" data-section="repos">
        <div class="pl-admin-menu__section-head">Repositories</div>
        <div class="pl-config-menu__row" data-loading>Loading repos…</div>
      </div>
      <div class="pl-admin-menu__section">
        <div class="pl-admin-menu__section-head">Danger zone</div>
        <button class="pl-btn pl-btn--danger" data-action="bulk-clear" type="button">Clear all comments on this page</button>
      </div>`, this.adminPopover.open(e, this.adminBtn);
    const n = e.querySelector('[data-action="track-page"]'), l = e.querySelector('[data-status="track-page"]');
    n && l && !i && n.addEventListener("click", async () => {
      n.disabled = !0;
      const h = n.textContent;
      n.textContent = "Tracking…", l.hidden = !0;
      try {
        const b = o?.key ?? this.deps.pageKey(), u = o?.title ?? document.title;
        await this.deps.api.call("pages.trackCurrent", {
          projectId: t.id,
          key: b,
          title: u,
          sourceKind: o?.sourceKind === "git" ? "git" : "live",
          sourceId: o?.sourceId ?? t.id
        }), n.textContent = "✓ Tracked", l.hidden = !1, l.textContent = "Page added to dashboard.";
      } catch (b) {
        n.disabled = !1, n.textContent = h ?? "Track this page", l.hidden = !1, l.textContent = `Failed: ${b instanceof Error ? b.message : String(b)}`;
      }
    });
    const d = e.querySelector('[data-action="bulk-clear"]');
    d.addEventListener("click", () => {
      const h = d.dataset.confirming === "1";
      this.actions.bulkClear(d), h && this.adminPopover.close();
    });
    const c = e.querySelector("#pl-admin-name"), p = e.querySelector('[data-action="rename-save"]'), m = e.querySelector(".pl-admin-project__status");
    c && p && m && s && p.addEventListener("click", async () => {
      const h = c.value.trim();
      if (!h || h === t.name) {
        m.hidden = !1, m.textContent = "Nothing to save.";
        return;
      }
      p.disabled = !0, p.textContent = "Saving…", m.hidden = !0;
      try {
        await this.deps.api.call("projects.update", {
          projectId: t.id,
          name: h
        }), m.hidden = !1, m.textContent = "Saved.";
      } catch (b) {
        m.hidden = !1, m.textContent = `Failed: ${b instanceof Error ? b.message : String(b)}`;
      } finally {
        p.disabled = !1, p.textContent = "Save";
      }
    });
    try {
      const h = await this.deps.api.call("repos.list", { projectId: this.deps.project().id }), b = e.querySelector('[data-section="repos"]')?.querySelector("[data-loading]");
      if (!b) return;
      if (h.length === 0) {
        b.outerHTML = '<div class="pl-config-menu__row"><em>No repos. Add one with <code>pageloop repo add</code>.</em></div>';
        return;
      }
      b.outerHTML = h.map((u) => {
        const v = u.lastSyncedAt ? new Date(u.lastSyncedAt).toLocaleString() : "never";
        return `<div class="pl-admin-repo">
          <div class="pl-admin-repo__head">${w(u.remoteUrl ?? u.workingDir ?? u.id)}</div>
          <div class="pl-admin-repo__meta">${w(u.defaultBranch)} · last sync: ${w(v)}</div>
          <button class="pl-btn pl-btn--mini" data-action="sync" data-repo-id="${u.id}" type="button">Sync now</button>
        </div>`;
      }).join(""), e.querySelectorAll('[data-action="sync"]').forEach((u) => {
        u.addEventListener("click", async () => {
          const v = u.dataset.repoId;
          u.disabled = !0, u.textContent = "Syncing…";
          const E = this.deps.bus.on("repo.sync.finished", (y) => {
            if (y?.repoId !== v) return;
            E(), g();
            const x = y.newVersionIds?.length ?? 0;
            u.textContent = x > 0 ? `+${x} version${x === 1 ? "" : "s"}` : "Up to date", setTimeout(() => {
              u.textContent = "Sync now", u.disabled = !1;
            }, 4e3);
          }), g = this.deps.bus.on("repo.sync.failed", (y) => {
            y?.repoId === v && (E(), g(), u.textContent = "Failed", R(this.deps.bus, "repo.sync", `Sync failed: ${y.error ?? "unknown"}`, y.error, { extra: { repoId: v } }), setTimeout(() => {
              u.textContent = "Sync now", u.disabled = !1;
            }, 4e3));
          });
          try {
            await this.deps.api.call("repo.sync", { repoId: v });
          } catch (y) {
            E(), g(), u.textContent = "Failed", R(this.deps.bus, "repo.sync", `Sync failed: ${y instanceof Error ? y.message : String(y)}`, y, { extra: { repoId: v } }), setTimeout(() => {
              u.textContent = "Sync now", u.disabled = !1;
            }, 4e3);
          }
        });
      });
    } catch (h) {
      const b = e.querySelector('[data-section="repos"] [data-loading]');
      b && (b.outerHTML = `<div class="pl-config-menu__row">Failed to load repos: ${w(String(h))}</div>`);
    }
  }
  destroy() {
    this.configPopover.close(), this.authPopover.close(), this.adminPopover.close(), this.root.remove();
  }
}, F = class {
  constructor(e, t, s) {
    r(this, "deps", void 0), r(this, "settings", void 0), r(this, "actions", void 0), r(this, "handle", void 0), r(this, "root", void 0), r(this, "countEl", void 0), r(this, "actionsEl", void 0), r(this, "bubbleEl", void 0), r(this, "userBtnEl", void 0), r(this, "bubblesBtnEl", void 0), r(this, "commentsBtnEl", void 0), r(this, "offAuth", null), r(this, "offBubbles", null), r(this, "offSidebar", null), r(this, "isExpanded", !1), r(this, "bubblesVisible", !0), r(this, "corner", void 0), r(this, "settingsPopover", new I()), r(this, "userPopover", new I()), r(this, "escListener", (i) => {
      i.key === "Escape" && this.isExpanded && this.setExpanded(!1);
    }), this.deps = e, this.settings = t, this.actions = s, this.corner = this.settings.get().widgetCornerOverride ?? e.ui().widgetCorner ?? "lower-right", this.root = document.createElement("div"), this.root.className = `pl-mini pl-mini--${this.corner}`, this.root.dataset.pageloop = "mini-widget", this.root.innerHTML = `
			<div class="pl-mini__actions" aria-hidden="true">
				<button class="pl-mini__act" data-action="picker" data-pl-tip="Pick an element to comment on" aria-label="Element picker">${B("target")}</button>
				<button class="pl-mini__act" data-action="comments" data-pl-tip="Open comments" aria-label="Open comments" aria-pressed="false">${B("chat-bubble")}</button>
				<button class="pl-mini__act" data-action="bubbles" data-pl-tip="Toggle comment bubbles" aria-label="Toggle comment bubbles" aria-pressed="false">${B("eye")}</button>
				<button class="pl-mini__act" data-action="settings" data-pl-tip="Settings" aria-label="Settings">${B("settings")}</button>
				<button class="pl-mini__act" data-action="user" data-pl-tip="Account" aria-label="Account">${B("user")}</button>
					<button class="pl-mini__act pl-mini__act--dismiss" data-action="dismiss" data-pl-tip="Hide PageLoop (until reload)" aria-label="Hide PageLoop until reload">${B("close")}</button>
			</div>
			<button type="button" class="pl-mini__bubble" data-pl-tip="PageLoop — click to expand" aria-label="PageLoop">
				<span class="pl-mini__count">0</span>
				<span class="pl-mini__logo" aria-hidden="true"><span class="pl-mini__logo-live">${M.wordmark.head}</span><span class="pl-mini__logo-docs">${M.wordmark.tail}</span></span>
			</button>
		`, document.documentElement.appendChild(this.root), this.countEl = this.root.querySelector(".pl-mini__count"), this.actionsEl = this.root.querySelector(".pl-mini__actions"), this.bubbleEl = this.root.querySelector(".pl-mini__bubble"), this.userBtnEl = this.actionsEl.querySelector('[data-action="user"]'), this.bubblesBtnEl = this.actionsEl.querySelector('[data-action="bubbles"]'), this.commentsBtnEl = this.actionsEl.querySelector('[data-action="comments"]'), this.applyUserIconState();
    const o = S.getItem("pl_bubbles_hidden") === "1";
    this.setBubblesActive(!o), this.offBubbles = this.deps.bus.on("bubbles:toggle", (i) => {
      this.setBubblesActive(!!i?.visible);
    }), this.setCommentsActive(!1), this.offSidebar = this.deps.bus.on("sidebar:toggle", (i) => {
      this.setCommentsActive(!!i?.open);
    }), this.offAuth = this.deps.bus.on("auth:changed", () => this.applyUserIconState()), this.wireEvents(), this.handle = {
      setUnreadCount: (i) => {
        this.countEl.textContent = String(i), this.root.classList.toggle("pl-mini--has-count", i > 0);
      },
      setBubblesVisible: (i) => {
        this.setBubblesActive(i);
      }
    };
  }
  wireEvents() {
    this.bubbleEl.addEventListener("click", (e) => {
      e.stopPropagation(), this.setExpanded(!this.isExpanded);
    }), this.actionsEl.addEventListener("click", (e) => {
      const t = e.target.closest("[data-action]");
      if (t)
        switch (e.stopPropagation(), t.dataset.action) {
          case "dismiss":
            this.deps.dismiss();
            break;
          case "bubbles":
            this.actions.toggleBubbles();
            break;
          case "comments":
            this.actions.toggleSidebar();
            break;
          case "picker":
            this.actions.togglePicker();
            break;
          case "user":
            this.toggleUserPanel(t);
            break;
          case "settings":
            this.toggleSettings(t);
            break;
        }
    }), document.addEventListener("keydown", this.escListener);
  }
  updateCorner(e) {
    this.corner !== e && (this.root.classList.remove(`pl-mini--${this.corner}`), this.root.classList.add(`pl-mini--${e}`), this.corner = e, this.settingsPopover.close());
  }
  setHidden(e) {
    this.root.classList.toggle("pl-mini--hidden", e), e && (this.setExpanded(!1), this.settingsPopover.close(), this.userPopover.close());
  }
  setExpanded(e) {
    this.isExpanded !== e && (this.isExpanded = e, this.root.classList.toggle("pl-mini--expanded", e), this.actionsEl.setAttribute("aria-hidden", e ? "false" : "true"), e || this.settingsPopover.close());
  }
  toggleSettings(e) {
    if (this.settingsPopover.isOpen()) {
      this.settingsPopover.close();
      return;
    }
    this.userPopover.close();
    const t = te(this.deps, this.settings);
    this.settingsPopover.open(t, e, this.popoverPlacement());
  }
  toggleUserPanel(e) {
    if (this.userPopover.isOpen()) {
      this.userPopover.close();
      return;
    }
    if (this.settingsPopover.close(), !this.deps.user()) {
      oe(this.deps);
      return;
    }
    const t = se(this.deps, { onAction: () => this.userPopover.close() });
    this.userPopover.open(t, e, this.popoverPlacement());
  }
  popoverPlacement() {
    return this.corner === "lower-right" || this.corner === "lower-left" ? "top" : "bottom";
  }
  applyUserIconState() {
    const e = !!this.deps.user();
    this.userBtnEl.dataset.signedIn = e ? "true" : "false", this.userBtnEl.innerHTML = B(e ? "user-filled" : "user");
  }
  setBubblesActive(e) {
    this.bubblesVisible = e, this.bubblesBtnEl.dataset.active = e ? "true" : "false", this.bubblesBtnEl.setAttribute("aria-pressed", String(e));
  }
  setCommentsActive(e) {
    this.commentsBtnEl.dataset.active = e ? "true" : "false", this.commentsBtnEl.setAttribute("aria-pressed", String(e));
  }
  setConnection(e) {
  }
  setReconnecting() {
  }
  destroy() {
    document.removeEventListener("keydown", this.escListener), this.offAuth?.(), this.offAuth = null, this.offBubbles?.(), this.offBubbles = null, this.offSidebar?.(), this.offSidebar = null, this.settingsPopover.close(), this.userPopover.close(), this.root.remove();
  }
}, ts = 20, Me = 336 * 60 * 60 * 1e3;
function Re(e) {
  return `${je}${e}`;
}
function ie(e) {
  const t = S.getItem(Re(e));
  if (!t) return {};
  try {
    const s = JSON.parse(t);
    return s && typeof s == "object" ? s : {};
  } catch {
    return {};
  }
}
function fe(e) {
  const t = Date.now(), s = Object.entries(e).filter(([, o]) => o && typeof o.savedAt == "number" && t - o.savedAt < Me).sort((o, i) => i[1].savedAt - o[1].savedAt).slice(0, ts);
  return Object.fromEntries(s);
}
function X(e, t) {
  const s = Re(e);
  if (Object.keys(t).length === 0) {
    S.removeItem(s);
    return;
  }
  S.setItem(s, JSON.stringify(t));
}
function ss(e, t) {
  const s = ie(e)[t];
  return s ? typeof s.savedAt == "number" && Date.now() - s.savedAt >= Me ? (Oe(e, t), null) : s : null;
}
function os(e, t, s) {
  const o = ie(e);
  if (!s.bodyMd.trim() && !s.anchor) {
    delete o[t], X(e, fe(o));
    return;
  }
  o[t] = {
    bodyMd: s.bodyMd,
    anchor: s.anchor,
    savedAt: Date.now()
  }, X(e, fe(o));
}
function Oe(e, t) {
  const s = ie(e);
  t in s && (delete s[t], X(e, s));
}
var Ie = class {
  constructor(e, t) {
    r(this, "deps", void 0), r(this, "onLoaded", void 0), r(this, "reactionTooltip", null), r(this, "reactionsPreloadAttempted", /* @__PURE__ */ new Set()), r(this, "pickerImport", null), this.deps = e, this.onLoaded = t;
  }
  wireRow(e) {
    const t = e.dataset.targetKind, s = e.dataset.targetId;
    if (!t || !s) return;
    e.querySelectorAll("[data-reaction-kind]").forEach((i) => {
      i.addEventListener("click", (a) => {
        a.stopPropagation();
        const n = i.dataset.reactionKind;
        n && this.deps.comments.toggleReaction(t, s, n);
      }), i.addEventListener("mouseenter", () => this.showTooltip(t, s, i)), i.addEventListener("mouseleave", () => this.hideTooltip());
    });
    const o = e.querySelector('[data-action="add-reaction"]');
    o?.addEventListener("click", (i) => {
      i.stopPropagation(), this.openPicker(t, s, o);
    });
  }
  preload(e) {
    const t = e.filter((i) => !this.reactionsPreloadAttempted.has(`comment:${i.id}`)).map((i) => ({
      kind: "comment",
      id: i.id
    })), s = [];
    for (const i of e) {
      const a = this.deps.comments.loadedReplies(i.id);
      if (a)
        for (const n of a)
          this.reactionsPreloadAttempted.has(`reply:${n.id}`) || s.push({
            kind: "reply",
            id: n.id
          });
    }
    const o = [...t, ...s];
    if (o.length !== 0) {
      for (const i of o) this.reactionsPreloadAttempted.add(`${i.kind}:${i.id}`);
      Promise.allSettled(o.map((i) => this.deps.comments.fetchReactions(i.kind, i.id))).then(() => this.onLoaded());
    }
  }
  preloadTargets(e) {
    const t = e.filter((s) => !this.reactionsPreloadAttempted.has(`${s.kind}:${s.id}`));
    if (t.length !== 0) {
      for (const s of t) this.reactionsPreloadAttempted.add(`${s.kind}:${s.id}`);
      Promise.allSettled(t.map((s) => this.deps.comments.fetchReactions(s.kind, s.id))).then(() => this.onLoaded());
    }
  }
  showTooltip(e, t, s) {
    this.hideTooltip();
    const o = s.dataset.reactionKind;
    if (!o) return;
    const i = this.deps.user(), a = this.deps.comments.loadedReactions(e, t).filter((c) => c.kind === o).sort((c, p) => c.createdAt.localeCompare(p.createdAt));
    if (a.length === 0) return;
    const n = (c) => i && c.userId === i.id ? "you" : c.authorName ?? c.userId.slice(0, 8), l = document.createElement("div");
    l.className = "pl-reaction-tooltip", l.innerHTML = `<div class="pl-reaction-tooltip__head">${w(et(o))}</div>` + a.map((c) => `<div class="pl-reaction-tooltip__row">${w(n(c))}</div>`).join(""), document.body.appendChild(l);
    const d = s.getBoundingClientRect();
    l.style.left = `${window.scrollX + d.left}px`, l.style.top = `${window.scrollY + d.bottom + 4}px`, this.reactionTooltip = l;
  }
  hideTooltip() {
    this.reactionTooltip?.remove(), this.reactionTooltip = null;
  }
  openPicker(e, t, s) {
    const o = {
      anchor: s,
      onPick: (i) => {
        this.deps.comments.toggleReaction(e, t, i);
      }
    };
    this.pickerImport || (this.pickerImport = import("./EmojiPicker-idF4EkZ7.js").catch((i) => {
      throw this.pickerImport = null, i;
    })), this.pickerImport.then((i) => i.openEmojiPicker(o));
  }
};
function is(e, t, s, o) {
  const i = t.querySelector(".pl-comment__body");
  t.classList.add("pl-comment--editing"), Se({
    bodyEl: i,
    original: s.bodyMd,
    layout: "block",
    onCancel: o,
    onSave: async (a) => {
      try {
        await e.comments.update({
          commentId: s.id,
          bodyMd: a
        });
      } catch (n) {
        R(e.bus, "comment.update", `Failed to save: ${n instanceof Error ? n.message : String(n)}`, n, { extra: { commentId: s.id } });
      }
    }
  });
}
function ns(e, t, s, o) {
  const i = t.querySelector(".pl-reply__body"), a = t.querySelector(".pl-reply__head");
  !i || !a || (t.classList.add("pl-reply--editing"), Se({
    bodyEl: i,
    metaEl: a,
    metaPrefixHtml: `<span class="pl-reply__meta-time">${new Date(s.createdAt).toLocaleString()}</span>`,
    original: s.bodyMd,
    layout: "inline",
    onCancel: o,
    onSave: async (n) => {
      try {
        await e.comments.updateReply(s.id, n);
      } catch (l) {
        R(e.bus, "reply.update", `Failed to save: ${l instanceof Error ? l.message : String(l)}`, l, { extra: { replyId: s.id } });
      }
    }
  }));
}
var as = class {
  constructor(e, t, s) {
    r(this, "deps", void 0), r(this, "reactions", void 0), r(this, "getComments", void 0), r(this, "expandedReplies", /* @__PURE__ */ new Set()), r(this, "repliesPreloadAttempted", /* @__PURE__ */ new Set()), this.deps = e, this.reactions = t, this.getComments = s;
  }
  isExpanded(e) {
    return this.expandedReplies.has(e);
  }
  async ensureExpanded(e) {
    const t = document.querySelector(".pl-sidebar__list");
    if (!t) return null;
    const s = t.querySelector(`[data-comment-id="${e}"] .pl-replies`);
    return s ? (this.expandedReplies.has(e) || (this.expandedReplies.add(e), s.dataset.expanded = "1", s.style.display = ""), this.deps.comments.loadedReplies(e) === null && await this.deps.comments.fetchReplies(e), this.render(e, s), s) : null;
  }
  wireToggle(e, t) {
    const s = e.querySelector('[data-action="toggle-replies"]'), o = e.querySelector(".pl-replies");
    o && this.expandedReplies.has(t) && (o.style.display = "", o.dataset.expanded = "1", this.deps.comments.loadedReplies(t) === null ? this.deps.comments.fetchReplies(t).then(() => this.render(t, o)) : this.render(t, o)), s?.addEventListener("click", async (i) => {
      i.stopPropagation(), o && (this.expandedReplies.has(t) ? (this.expandedReplies.delete(t), o.dataset.expanded = "0", o.style.display = "none", o.innerHTML = "") : (this.expandedReplies.add(t), o.dataset.expanded = "1", o.style.display = "", this.deps.comments.loadedReplies(t) === null && await this.deps.comments.fetchReplies(t), this.render(t, o)));
    });
  }
  preloadCounts(e, t) {
    const s = e.filter((o) => !this.repliesPreloadAttempted.has(o.id) && this.deps.comments.loadedReplies(o.id) === null);
    if (s.length !== 0) {
      for (const o of s) this.repliesPreloadAttempted.add(o.id);
      Promise.allSettled(s.map((o) => this.deps.comments.fetchReplies(o.id))).then(() => t());
    }
  }
  render(e, t) {
    const s = this.deps.comments.loadedReplies(e) ?? [], o = this.deps.user(), i = this.deps.role(), a = i === "editor" || i === "owner", n = s.map((h) => {
      const b = !!o && h.authorId === o.id, u = b, v = b || a, E = [];
      u && E.push(`<button class="pl-comment__action-btn" data-reply-action="edit" data-reply-id="${h.id}" data-pl-tip="Edit" aria-label="Edit">${_("edit")}</button>`), v && E.push(`<button class="pl-comment__action-btn pl-comment__action-btn--danger" data-reply-action="delete" data-reply-id="${h.id}" data-pl-tip="Delete" aria-label="Delete">${_("trash")}</button>`);
      const g = E.length > 0 ? `<div class="pl-reply__actions">${E.join("")}</div>` : "", y = Ee("reply", h.id, this.deps.comments.loadedReactions("reply", h.id), o?.id ?? null);
      return `<div class="pl-reply" data-reply-id="${h.id}">
        ${g}
        <div class="pl-reply__head">
          <span class="pl-reply__author">${w(h.authorName ?? h.authorId)}</span>
          <span class="pl-reply__sep" aria-hidden="true">·</span>
          <span class="pl-reply__time">${new Date(h.createdAt).toLocaleString()}</span>
        </div>
        <div class="pl-reply__body pl-md">${xe(h.bodyMd)}</div>
        ${y}
      </div>`;
    }).join(""), l = !this.deps.user(), d = !!this.deps.project().settings.policies?.publicComments, c = !l || d;
    let p = "";
    c ? p = `
        <div class="pl-reply-input">
          <form>
            ${l && d ? `<input class="pl-reply-input__name" type="text" placeholder="Your name" maxlength="60" value="${w(S.getItem("pl_guest_name") ?? "")}">` : ""}
            <textarea placeholder="Reply…" rows="1"></textarea>
            <button class="pl-btn pl-btn--primary" type="submit">Post</button>
          </form>
        </div>
      ` : p = '<div class="pl-reply-input"><em style="color:var(--pl-color-text-soft);font-size:11px;">Sign in to reply.</em></div>', t.innerHTML = n + p, t.querySelectorAll("[data-reply-action]").forEach((h) => {
      h.addEventListener("click", (b) => {
        b.stopPropagation(), this.handleAction(e, h.dataset.replyId, h.dataset.replyAction, t, h);
      });
    }), t.querySelectorAll(".pl-reactions").forEach((h) => this.reactions.wireRow(h)), this.reactions.preload(this.getComments());
    const m = t.querySelector("form");
    m?.addEventListener("submit", async (h) => {
      h.preventDefault();
      const b = m.querySelector("textarea"), u = m.querySelector(".pl-reply-input__name"), v = b.value.trim();
      if (!v) return;
      let E;
      if (u) {
        if (E = u.value.trim(), !E) {
          u.focus();
          return;
        }
        S.setItem("pl_guest_name", E);
      }
      try {
        await this.deps.comments.reply(e, v, E), await this.deps.comments.fetchReplies(e), this.render(e, t);
      } catch (g) {
        R(this.deps.bus, "reply.create", `Failed to post reply: ${g instanceof Error ? g.message : String(g)}`, g, { extra: { commentId: e } });
      }
    });
  }
  async handleAction(e, t, s, o, i) {
    const a = (this.deps.comments.loadedReplies(e) ?? []).find((l) => l.id === t);
    if (!a) return;
    if (s === "delete") {
      if (!Z(i, "Click again to delete · Esc to cancel")) return;
      try {
        await this.deps.comments.deleteReply(t);
      } catch (l) {
        R(this.deps.bus, "reply.delete", `Failed to delete reply: ${l instanceof Error ? l.message : String(l)}`, l, { extra: { replyId: t } });
      }
      return;
    }
    if (s !== "edit") return;
    const n = o.querySelector(`.pl-reply[data-reply-id="${t}"]`);
    n && ns(this.deps, n, a, () => {
      n.classList.remove("pl-reply--editing"), this.render(e, o);
    });
  }
}, ls = class {
  constructor(e, t, s, o) {
    r(this, "deps", void 0), r(this, "listEl", void 0), r(this, "onFocusComment", void 0), r(this, "isActive", void 0), r(this, "reactions", void 0), r(this, "replies", void 0), r(this, "state", {
      page: null,
      comments: []
    }), this.deps = e, this.listEl = t, this.onFocusComment = s, this.isActive = o, this.reactions = new Ie(this.deps, () => {
      this.isActive() && this.render(this.state);
    }), this.replies = new as(this.deps, this.reactions, () => this.state.comments);
  }
  render(e) {
    if (this.state = e, this.listEl.className = "pl-sidebar__list", e.loading) {
      this.listEl.innerHTML = `
        <div class="pl-empty pl-empty--loading">
          <span class="pl-empty__spinner" aria-hidden="true"></span>
          <div class="pl-empty__hint">Loading comments…</div>
        </div>`;
      return;
    }
    if (!e.page) {
      this.listEl.innerHTML = `
        <div class="pl-empty">
          ${le("no-page")}
          <div class="pl-empty__title">This page isn't tracked yet</div>
          <div class="pl-empty__hint">Comments will appear here once this URL is being tracked.</div>
        </div>`;
      return;
    }
    if (e.comments.length === 0) {
      const o = this.deps.role(), i = o === "owner" || o === "editor" || o === "commenter" ? `<button type="button" class="pl-empty__cta">${_("target")}<span>Pick an element to comment</span></button>` : "";
      this.listEl.innerHTML = `
        <div class="pl-empty">
          ${le("no-comments")}
          <div class="pl-empty__title">No comments yet</div>
          <div class="pl-empty__hint">Highlight any text on the page, or pick an element, to leave the first note.</div>
          ${i}
        </div>`, this.listEl.querySelector(".pl-empty__cta")?.addEventListener("click", () => this.deps.bus.emit("sidebar:request-pick", {}));
      return;
    }
    const t = e.focusedCommentIds ? e.focusedCommentIds : e.focusedCommentId ? /* @__PURE__ */ new Set([e.focusedCommentId]) : null, s = e.danglingCommentIds ?? null;
    this.listEl.innerHTML = e.comments.map((o) => this.commentHtml(o, t, s?.has(o.id))).join(""), this.wireCommentInteractions(), this.replies.preloadCounts(e.comments, () => {
      this.isActive() && this.render(this.state);
    }), this.reactions.preload(e.comments);
  }
  wireCommentInteractions() {
    this.listEl.querySelectorAll(".pl-comment").forEach((e) => {
      const t = e.dataset.commentId;
      e.addEventListener("click", (o) => {
        e.classList.contains("pl-comment--editing") || o.target.closest("button, textarea, .pl-reaction-picker") || this.onFocusComment(t);
      }), e.querySelectorAll("[data-comment-action]").forEach((o) => {
        o.addEventListener("click", (i) => {
          i.stopPropagation(), this.handleAction(t, o.dataset.commentAction, e, o);
        });
      });
      const s = e.querySelector(":scope > .pl-comment__meta > .pl-reactions");
      s && this.reactions.wireRow(s), this.replies.wireToggle(e, t);
    });
  }
  async handleAction(e, t, s, o) {
    const i = this.state.comments.find((a) => a.id === e);
    if (i) {
      if (t === "edit") is(this.deps, s, i, () => {
        s.classList.remove("pl-comment--editing"), this.render(this.state);
      });
      else if (t === "reanchor") this.deps.bus.emit("sidebar:request-reanchor", { commentId: e });
      else if (t === "copy-agent-link") {
        const a = this.deps.page()?.id;
        a && Ke(this.deps, {
          pageId: a,
          commentId: e
        });
      } else if (t === "copy-comment") {
        const a = i.anchor?.exact ? `"${i.anchor.exact}"
` : "";
        try {
          await navigator.clipboard.writeText(`${a}${i.bodyMd}`), this.deps.bus.emit("toast:show", {
            kind: "success",
            message: "Comment copied"
          });
        } catch (n) {
          R(this.deps.bus, "comment.copy", "Couldn't copy the comment.", n, { extra: { commentId: e } });
        }
      } else if (t === "add-task" || t === "remove-task" || t === "complete-task" || t === "reopen-task") {
        const a = t === "add-task" ? { isTask: !0 } : t === "remove-task" ? { isTask: !1 } : { resolved: t === "complete-task" };
        try {
          await this.deps.comments.setTask({
            commentId: e,
            ...a
          }), t === "add-task" && this.deps.bus.emit("toast:show", {
            kind: "success",
            message: "Comment added as a task."
          });
        } catch (n) {
          R(this.deps.bus, `comment.${t}`, `Failed: ${n instanceof Error ? n.message : String(n)}`, n, { extra: {
            commentId: e,
            action: t
          } });
        }
      } else if (t === "delete") {
        if (!Z(o, "Click again to delete · Esc to cancel")) return;
        try {
          await this.deps.comments.delete(e), this.deps.bus.emit("toast:show", {
            kind: "info",
            message: "Comment deleted"
          });
        } catch (a) {
          R(this.deps.bus, "comment.delete", `Failed to delete: ${a instanceof Error ? a.message : String(a)}`, a, { extra: { commentId: e } });
        }
      }
    }
  }
  commentHtml(e, t, s = !1) {
    const o = this.deps.user(), i = this.deps.role(), a = o?.id === e.authorId, n = i === "editor" || i === "owner", l = a, d = a || n, c = !!this.deps.project().settings.policies?.publicComments, p = n || o?.platformRole === "superadmin", m = e.isTask && e.status === "resolved", h = t?.has(e.id) ? " is-focused" : "", b = m ? " pl-comment--resolved" : "", u = (e.isTask ? " pl-comment--task" : "") + (s ? " pl-comment--dangling" : ""), v = e.anchor?.exact ? `<div class="pl-comment__excerpt">"${w(e.anchor.exact.slice(0, 120))}"</div>` : "", E = m ? " pl-comment__task-chip--done" : "", g = e.isTask ? p ? `<button class="pl-comment__task-chip${E}" data-comment-action="remove-task" data-pl-tip="Remove task" aria-label="Remove task">todo</button>` : `<span class="pl-comment__task-chip pl-comment__task-chip--readonly${E}" data-pl-tip="${m ? "Completed task" : "Task"}" aria-label="${m ? "Completed task" : "Task"}">todo</span>` : "", y = [];
    y.push(`<button class="pl-comment__action-btn" data-comment-action="copy-comment" data-pl-tip="Copy comment text" aria-label="Copy comment text">${_("copy")}</button>`), l && y.push(`<button class="pl-comment__action-btn" data-comment-action="edit" data-pl-tip="Edit" aria-label="Edit">${_("edit")}</button>`), p && (e.isTask ? m ? y.push(`<button class="pl-comment__action-btn" data-comment-action="reopen-task" data-pl-tip="Mark incomplete" aria-label="Mark incomplete">${_("reopen")}</button>`) : y.push(`<button class="pl-comment__action-btn" data-comment-action="complete-task" data-pl-tip="Mark complete" aria-label="Mark complete">${_("check")}</button>`) : y.push(`<button class="pl-comment__action-btn" data-comment-action="add-task" data-pl-tip="Add as task" aria-label="Add as task">${_("plus")}</button>`), e.isTask && y.push(`<button class="pl-comment__action-btn" data-comment-action="copy-agent-link" data-pl-tip="Copy agent link (this task)" aria-label="Copy agent link for this task">${_("link")}</button>`)), d && y.push(`<button class="pl-comment__action-btn pl-comment__action-btn--danger" data-comment-action="delete" data-pl-tip="Delete" aria-label="Delete">${_("trash")}</button>`);
    const x = y.length > 0 ? `<div class="pl-comment__actions">${y.join("")}</div>` : "", P = Ee("comment", e.id, this.deps.comments.loadedReactions("comment", e.id), o?.id ?? null), k = this.deps.comments.loadedReplies(e.id)?.length ?? 0, f = k > 0 ? `<span class="pl-replies-badge" data-pl-tip="${k} repl${k === 1 ? "y" : "ies"}">${k}</span>` : "", C = o || c ? `<button class="pl-replies-toggle${k > 0 ? " pl-replies-toggle--has" : ""}" data-action="toggle-replies">Reply${f}</button>` : k > 0 ? `<button class="pl-replies-toggle pl-replies-toggle--has" data-action="toggle-replies">${k} repl${k === 1 ? "y" : "ies"}</button>` : "", L = w(Q(e.authorName)), $ = a || n, A = s ? $ ? '<button class="pl-comment__no-anchor pl-comment__no-anchor--action" data-comment-action="reanchor" data-pl-tip="Pick a new element to re-anchor this comment" aria-label="Re-anchor this comment">no anchor</button>' : `<span class="pl-comment__no-anchor" title="The text this comment was attached to isn't in the current page content. Edit the page or anchor the comment again to relink it.">no anchor</span>` : "", H = !s && e.anchor && $ ? `<button class="pl-comment__reanchor" data-comment-action="reanchor" data-pl-tip="Change the element this comment is anchored to" aria-label="Change anchor">${_("target")}</button>` : "", ae = s ? A : H, De = g || ae ? `<div class="pl-comment__chips">${g}${ae}</div>` : "";
    return `<div class="pl-comment${h}${u}${b}" data-comment-id="${e.id}">
      ${x}
      ${De}
      ${v}
      <div class="pl-comment__body pl-md">${xe(e.bodyMd)}</div>
      <div class="pl-comment__meta">
        <span><strong>${L}</strong> · <span class="pl-comment__time" title="${w(new Date(e.createdAt).toLocaleString())}">${w(Ce(e.createdAt, { style: "compact" }))}</span></span>
        ${C}
        ${P}
      </div>
      <div class="pl-replies" data-expanded="0" style="display: none;"></div>
    </div>`;
  }
}, rs = class {
  constructor(e, t) {
    r(this, "deps", void 0), r(this, "listEl", void 0), r(this, "expandedDiffs", /* @__PURE__ */ new Set()), r(this, "diffCache", /* @__PURE__ */ new Map()), this.deps = e, this.listEl = t;
  }
  async render() {
    const e = this.deps.page();
    if (!e) {
      this.listEl.innerHTML = '<div class="pl-sidebar__empty">No tracked page for this URL.</div>';
      return;
    }
    this.listEl.innerHTML = '<div class="pl-sidebar__empty">Loading versions…</div>';
    try {
      const t = await this.deps.api.call("versions.list", { trackedPageId: e.id });
      if (t.length === 0) {
        this.listEl.innerHTML = '<div class="pl-sidebar__empty">No versions captured yet.<br><small>Versions are captured when a tracked git repo syncs.</small></div>';
        return;
      }
      this.listEl.className = "pl-sidebar__list pl-changes";
      const s = [...t].sort((o, i) => i.capturedAt.localeCompare(o.capturedAt));
      this.listEl.innerHTML = s.map((o, i) => {
        const a = s[i + 1], n = this.expandedDiffs.has(o.id);
        return `<div class="pl-version" data-version-id="${o.id}" data-prev-id="${a?.id ?? ""}">
          <button class="pl-version__row" type="button" data-action="toggle-diff">
            <span class="pl-version__ref">${w(o.kind)}: <code>${w(o.ref.slice(0, 12))}</code></span>
            <span class="pl-version__meta">${w(new Date(o.capturedAt).toLocaleString())}</span>
            <span class="pl-version__chevron">${n ? _("chevron-down") : _("chevron-right")}</span>
          </button>
          <div class="pl-version__diff" ${n ? "" : "hidden"}></div>
        </div>`;
      }).join(""), this.listEl.querySelectorAll(".pl-version").forEach((o) => {
        const i = o.dataset.versionId, a = o.dataset.prevId || null;
        o.querySelector('[data-action="toggle-diff"]').addEventListener("click", () => {
          this.toggleDiff(e.id, i, a, o);
        }), this.expandedDiffs.has(i) && this.renderDiffInto(e.id, i, a, o);
      });
    } catch (t) {
      this.listEl.innerHTML = `<div class="pl-sidebar__empty">Failed to load versions: ${w(String(t))}</div>`;
    }
  }
  async toggleDiff(e, t, s, o) {
    const i = o.querySelector(".pl-version__diff"), a = o.querySelector(".pl-version__chevron");
    if (this.expandedDiffs.has(t)) {
      this.expandedDiffs.delete(t), i.hidden = !0, i.innerHTML = "", a.innerHTML = _("chevron-right");
      return;
    }
    this.expandedDiffs.add(t), i.hidden = !1, a.innerHTML = _("chevron-down"), await this.renderDiffInto(e, t, s, o);
  }
  async renderDiffInto(e, t, s, o) {
    const i = o.querySelector(".pl-version__diff");
    if (!s) {
      i.innerHTML = '<div class="pl-version__diff-empty"><em>Initial version — no predecessor to diff against.</em></div>';
      return;
    }
    const a = `${s}..${t}`;
    let n = this.diffCache.get(a);
    if (!n) {
      i.innerHTML = '<div class="pl-version__diff-empty">Loading diff…</div>';
      try {
        n = await this.deps.api.call("versions.diff", {
          trackedPageId: e,
          from: s,
          to: t
        }), this.diffCache.set(a, n);
      } catch (l) {
        i.innerHTML = `<div class="pl-version__diff-empty">Failed to load diff: ${w(String(l))}</div>`;
        return;
      }
    }
    if (n.lines.length === 0) {
      i.innerHTML = '<div class="pl-version__diff-empty"><em>No textual difference.</em></div>';
      return;
    }
    i.innerHTML = `<div class="pl-diff">${n.lines.map((l) => `<div class="pl-diff__line ${l.op === "add" ? "pl-diff__line--add" : l.op === "remove" ? "pl-diff__line--remove" : "pl-diff__line--context"}"><span class="pl-diff__sigil">${l.op === "add" ? "+" : l.op === "remove" ? "-" : " "}</span><span class="pl-diff__text">${w(l.text)}</span></div>`).join("")}</div>`;
  }
}, cs = class {
  constructor(e, t, s) {
    r(this, "deps", void 0), r(this, "settings", void 0), r(this, "controls", void 0), r(this, "el", void 0), r(this, "settingsPopover", new I()), r(this, "userPopover", new I()), r(this, "bubblesBtn", void 0), r(this, "chatBtn", void 0), r(this, "offs", []), this.deps = e, this.settings = t, this.controls = s, this.el = document.createElement("div"), this.el.className = "pl-sidebar__footer", this.el.setAttribute("role", "group"), this.el.setAttribute("aria-label", "Sidebar controls"), this.el.innerHTML = `
      <button class="pl-sidebar__fbtn" type="button" data-faction="picker" data-pl-tip="Pick an element to comment on" aria-label="Pick an element">${_("target")}</button>
      <button class="pl-sidebar__fbtn" type="button" data-faction="bubbles" data-pl-tip="Toggle comment bubbles" aria-label="Toggle comment bubbles" aria-pressed="true">${_("eye")}</button>
      <button class="pl-sidebar__fbtn" type="button" data-faction="sidebar" data-active="true" aria-pressed="true" data-pl-tip="Comments sidebar open — click to close" aria-label="Close comments sidebar">${_("chat-bubble")}</button>
      <button class="pl-sidebar__fbtn" type="button" data-faction="chat" data-pl-tip="Toggle chat" aria-label="Toggle chat" aria-pressed="false" hidden>${_("messages")}</button>
      <span class="pl-sidebar__fspacer"></span>
      <button class="pl-sidebar__fbtn" type="button" data-faction="settings" data-pl-tip="Settings" aria-label="Settings">${_("settings")}</button>
      <button class="pl-sidebar__fbtn" type="button" data-faction="user" data-pl-tip="Account" aria-label="Account">${_("user")}</button>
    `, this.bubblesBtn = this.el.querySelector('[data-faction="bubbles"]'), this.chatBtn = this.el.querySelector('[data-faction="chat"]'), this.el.addEventListener("click", (i) => {
      const a = i.target.closest("[data-faction]");
      if (a)
        switch (a.dataset.faction) {
          case "sidebar":
            this.controls.closeSidebar();
            break;
          case "picker":
            this.controls.togglePicker();
            break;
          case "bubbles":
            this.controls.toggleBubbles();
            break;
          case "chat":
            this.controls.toggleChat();
            break;
          case "settings":
            this.toggleSettings(a);
            break;
          case "user":
            this.toggleUser(a);
            break;
        }
    });
    const o = S.getItem("pl_bubbles_hidden") === "1";
    this.setBubblesActive(!o), this.offs.push(this.deps.bus.on("bubbles:toggle", (i) => this.setBubblesActive(!!i?.visible)));
  }
  setBubblesActive(e) {
    this.bubblesBtn.dataset.active = String(e), this.bubblesBtn.setAttribute("aria-pressed", String(e));
  }
  setChatAvailable(e) {
    this.chatBtn.hidden = !e;
  }
  setChatActive(e) {
    this.chatBtn.dataset.active = String(e), this.chatBtn.setAttribute("aria-pressed", String(e));
  }
  toggleSettings(e) {
    if (this.settingsPopover.isOpen()) {
      this.settingsPopover.close();
      return;
    }
    this.userPopover.close(), this.settingsPopover.open(te(this.deps, this.settings), e, "top");
  }
  toggleUser(e) {
    if (this.userPopover.isOpen()) {
      this.userPopover.close();
      return;
    }
    if (this.settingsPopover.close(), !this.deps.user()) {
      oe(this.deps);
      return;
    }
    const t = se(this.deps, { onAction: () => this.userPopover.close() });
    this.userPopover.open(t, e, "top");
  }
  destroy() {
    this.settingsPopover.close(), this.userPopover.close();
    for (const e of this.offs) e();
    this.offs.length = 0, this.el.remove();
  }
}, ds = class {
  constructor(e, t, s, o) {
    r(this, "deps", void 0), r(this, "settings", void 0), r(this, "actions", void 0), r(this, "bodyPadding", void 0), r(this, "handle", void 0), r(this, "root", void 0), r(this, "listEl", void 0), r(this, "pageEl", void 0), r(this, "composeEl", null), r(this, "composeAnchor", null), r(this, "draftSaveTimer", null), r(this, "state", {
      page: null,
      comments: []
    }), r(this, "activeTab", "comments"), r(this, "controlsEl", null), r(this, "footer", null), r(this, "chatOpen", !1), r(this, "agentMenu", new I()), r(this, "pagesMenu", new I()), r(this, "showComments", !0), r(this, "showTasks", !0), r(this, "commentsTab", void 0), r(this, "changesTab", void 0), r(this, "chatManager", null), r(this, "chatPanel", null), r(this, "lastSeenPageId", null), r(this, "inPageObservers", null), r(this, "previouslyFocused", null), r(this, "onEscapeKey", (l) => {
      l.key === "Escape" && this.root.classList.contains("pl-sidebar--open") && this.handle.close();
    }), r(this, "chatImport", null), this.deps = e, this.settings = t, this.actions = s, this.bodyPadding = o, this.root = document.createElement("aside"), this.root.className = "pl-sidebar", this.root.setAttribute("role", "complementary"), this.root.setAttribute("aria-label", "PageLoop comments"), this.root.innerHTML = `
      <div class="pl-sidebar__header">
        <span class="pl-sidebar__brand">
          <span class="pl-sidebar__brand-row">
            <a class="pl-sidebar__title" href="https://${M.domain}" target="_blank" rel="noopener noreferrer" aria-label="${M.nameTitle} — ${M.domain}" data-pl-tip="Visit ${M.domain}"><span class="pl-sidebar__title-head">${M.wordmark.head}</span><span class="pl-sidebar__title-tail">${M.wordmark.tail}</span></a>
            <span class="pl-sidebar__version" data-pl-tip="@pageloop/vanilla@${U}">v${U}</span>
          </span>
          <span class="pl-sidebar__page" hidden></span>
        </span>
        <span class="pl-sidebar__header-actions">
          <button class="pl-sidebar__pages" type="button" aria-haspopup="menu" data-pl-tip="Pages with comments" aria-label="Pages with comments">${_("pages")}</button>
          <button class="pl-sidebar__mode" type="button" data-pl-tip="Toggle Flyout / In-Page" aria-label="Toggle display mode">${_("expand-out")}</button>
          <button class="pl-sidebar__close" type="button" data-pl-tip="Close (same as Comments toolbar button)" aria-label="Close sidebar">${_("close")}</button>
        </span>
      </div>
      <div class="pl-sidebar__tabs" role="tablist" aria-label="Sidebar sections">
        <button class="pl-sidebar__tab" role="tab" id="pl-tab-comments" aria-controls="pl-sidebar-panel" data-tab="comments" data-active="true" aria-selected="true">Comments</button>
        <button class="pl-sidebar__tab" role="tab" id="pl-tab-changes" aria-controls="pl-sidebar-panel" data-tab="changes" data-active="false" aria-selected="false">Changes</button>
      </div>
      <div class="pl-sidebar__controls">
        <div class="pl-sidebar__filters" role="group" aria-label="Filter by kind">
          <button class="pl-filter-chip" type="button" data-filter="comments" data-active="true" aria-pressed="true" data-pl-tip="Show / hide plain comments">Comments</button>
          <button class="pl-filter-chip" type="button" data-filter="tasks" data-active="true" aria-pressed="true" data-pl-tip="Show / hide tasks">Tasks</button>
        </div>
        <button class="pl-sidebar__agent-link" type="button" hidden aria-haspopup="menu" aria-expanded="false" data-pl-tip="Copy this page's unresolved tasks for an AI agent — as a ready-to-run prompt or JSON, or a tokenised link to either (works on private pages via a short-lived, revocable token)" aria-label="Agent link options">${_("link")}<span>Agent link…</span>${_("chevron-down")}</button>
      </div>
      <div class="pl-sidebar__list" id="pl-sidebar-panel" role="tabpanel" aria-labelledby="pl-tab-comments"></div>
      <div class="pl-sidebar__resize" data-pl-tip="Drag to resize" aria-hidden="true"></div>
    `, document.body.appendChild(this.root), this.listEl = this.root.querySelector(".pl-sidebar__list"), this.pageEl = this.root.querySelector(".pl-sidebar__page"), this.listEl.innerHTML = `
      <div class="pl-skeleton" aria-hidden="true">
        ${'<div class="pl-skeleton__row"><div class="pl-skeleton__avatar"></div><div class="pl-skeleton__col"><div class="pl-skeleton__line pl-skeleton__line--w70"></div><div class="pl-skeleton__line pl-skeleton__line--w90"></div><div class="pl-skeleton__line pl-skeleton__line--w50"></div></div></div>'.repeat(3)}
      </div>`, this.commentsTab = new ls(this.deps, this.listEl, (l) => this.focusComment(l), () => this.activeTab === "comments"), this.changesTab = new rs(this.deps, this.listEl), this.root.querySelector(".pl-sidebar__close").addEventListener("click", () => this.handle.close()), this.root.querySelector(".pl-sidebar__mode").addEventListener("click", () => this.toggleDisplayMode()), this.root.querySelector(".pl-sidebar__pages").addEventListener("click", (l) => {
      l.stopPropagation(), this.openPagesMenu(l.currentTarget);
    }), this.root.querySelectorAll(".pl-sidebar__tab").forEach((l) => {
      l.addEventListener("click", () => this.switchTab(l.dataset.tab));
    }), this.controlsEl = this.root.querySelector(".pl-sidebar__controls");
    const i = this.settings.get();
    this.showComments = i.showComments, this.showTasks = i.showTasks, this.controlsEl?.querySelectorAll(".pl-filter-chip").forEach((l) => {
      l.addEventListener("click", () => {
        const d = l.dataset.filter;
        d === "comments" ? this.showComments = !this.showComments : d === "tasks" && (this.showTasks = !this.showTasks), this.settings.update({
          showComments: this.showComments,
          showTasks: this.showTasks
        }), this.render(this.state);
      });
    }), this.controlsEl?.querySelector(".pl-sidebar__agent-link")?.addEventListener("click", (l) => {
      l.stopPropagation(), this.openAgentMenu(l.currentTarget);
    }), this.actions.controls && (this.footer = new cs(this.deps, this.settings, {
      ...this.actions.controls,
      toggleChat: () => this.toggleChat()
    }), this.root.appendChild(this.footer.el), this.syncFooterChat()), this.wireResizeHandle();
    const a = () => {
      this.listEl.style.setProperty("--pl-comment-gap", `${it[t.get().commentSpacing]}px`);
    };
    a(), t.subscribe(a), e.bus.on("reaction:changed", () => this.render(this.state)), e.bus.on("reply:created", () => this.render(this.state)), e.bus.on("reply:updated", () => this.render(this.state)), e.bus.on("reply:deleted", () => this.render(this.state)), e.bus.on("auth:changed", () => {
      this.composeHasContent() || (this.closeCompose(), this.activeTab === "comments" && this.ensureCompose()), this.syncFooterChat();
    });
    const n = (l) => {
      const d = this.root.classList.contains("pl-sidebar--open");
      if (this.root.classList.toggle("pl-sidebar--open", l), Ze(l), e.bus.emit("sidebar:toggle", { open: l }), l && !d)
        this.previouslyFocused = document.activeElement instanceof HTMLElement ? document.activeElement : null, document.addEventListener("keydown", this.onEscapeKey), this.focusFirstInteractive();
      else if (!l && d) {
        document.removeEventListener("keydown", this.onEscapeKey);
        const c = this.previouslyFocused;
        this.previouslyFocused = null, c && document.contains(c) && c.focus();
      }
    };
    this.handle = {
      open: () => n(!0),
      close: () => n(!1),
      toggle: () => n(!this.root.classList.contains("pl-sidebar--open")),
      focusComment: (l) => this.focusComment(l),
      focusReply: (l, d) => this.focusReply(l, d)
    }, Xe() === !0 && n(!0);
  }
  maybeMountChat() {
    if (this.chatManager || this.chatImport) return;
    const e = this.deps.project();
    if (!e.settings.chat?.enabled) return;
    const t = this.deps.user(), s = !!e.settings.policies?.publicComments;
    !t && !s || (this.chatImport = import("./Chat-BTiH6Skr.js").then((o) => {
      if (this.chatManager) return o;
      const i = new o.ChatManager({
        api: this.deps.api,
        bus: this.deps.bus,
        project: () => this.deps.project(),
        page: () => this.deps.page(),
        user: () => this.deps.user(),
        organizationId: () => e.organizationId ?? null
      }), a = new Ie(this.deps, () => {
        n.repaintActiveMessages();
      }), n = new o.ChatPanel({
        manager: i,
        bus: this.deps.bus,
        uiDeps: this.deps,
        reactions: a,
        mountIn: this.root
      });
      this.chatManager = i, this.chatPanel = n, this.chatOpen && n.expand(), this.pinFooterLast();
      const l = i.resolveOpeningRoom();
      return i.setRoom(l).then(() => i.saveLastRoom()), o;
    }).catch((o) => {
      throw this.chatImport = null, this.deps.debug("[chat] dynamic import failed", o), o;
    }));
  }
  pinFooterLast() {
    this.footer && this.root.appendChild(this.footer.el);
  }
  isChatAvailable() {
    const e = this.deps.project();
    if (!e.settings.chat?.enabled) return !1;
    const t = this.deps.user(), s = !!e.settings.policies?.publicComments;
    return !!t || s;
  }
  syncFooterChat() {
    this.footer?.setChatAvailable(this.isChatAvailable()), this.footer?.setChatActive(this.chatOpen);
  }
  toggleChat() {
    this.isChatAvailable() && (this.chatOpen = !this.chatOpen, this.chatOpen && (this.maybeMountChat(), this.chatPanel?.expand()), this.root.classList.toggle("pl-sidebar--chat-open", this.chatOpen), this.syncFooterChat());
  }
  openAgentMenu(e) {
    if (this.agentMenu.isOpen()) {
      this.agentMenu.close();
      return;
    }
    const t = this.deps.page()?.id;
    if (!t) return;
    const s = document.createElement("div");
    s.className = "pl-config-menu pl-agent-menu";
    const o = [
      {
        label: "Copy task list as Prompt",
        kind: "prompt",
        mode: "content"
      },
      {
        label: "Copy task list as JSON",
        kind: "json",
        mode: "content"
      },
      {
        label: "Copy Prompt link",
        kind: "prompt",
        mode: "link"
      },
      {
        label: "Copy JSON link",
        kind: "json",
        mode: "link"
      },
      {
        label: "Copy task list as prompt for all pages",
        allPages: !0
      }
    ];
    s.innerHTML = o.map((i, a) => `<button class="pl-config-menu__item pl-agent-menu__item" type="button" data-agent-idx="${a}">${w(i.label)}</button>`).join(""), s.querySelectorAll("[data-agent-idx]").forEach((i) => {
      i.addEventListener("click", () => {
        const a = o[Number(i.dataset.agentIdx)];
        if (this.agentMenu.close(), !!a) {
          if (a.allPages) {
            const n = this.deps.project()?.id;
            n && nt(this.deps, { projectId: n });
            return;
          }
          Je(this.deps, {
            pageId: t,
            kind: a.kind,
            mode: a.mode
          });
        }
      });
    }), this.agentMenu.open(s, e, "bottom");
  }
  openPagesMenu(e) {
    if (this.pagesMenu.isOpen()) {
      this.pagesMenu.close();
      return;
    }
    const t = this.deps.project()?.id;
    if (!t) return;
    const s = document.createElement("div");
    s.className = "pl-config-menu pl-pages-menu", s.innerHTML = '<div class="pl-pages-menu__status">Loading pages…</div>', this.pagesMenu.open(s, e, "bottom");
    const o = this.root.getBoundingClientRect();
    s.style.left = `${Math.max(8, o.left)}px`, s.style.right = "auto", s.style.width = `${o.width}px`, this.loadPagesInto(s, t);
  }
  async loadPagesInto(e, t) {
    try {
      const s = await this.deps.api.call("pages.list", {
        projectId: t,
        hasComments: !0,
        sort: "lastCommentedAt",
        dir: "desc",
        limit: 200
      });
      if (!this.pagesMenu.isOpen()) return;
      const o = s.pages ?? [];
      if (o.length === 0) {
        e.innerHTML = '<div class="pl-pages-menu__status">No pages have comments yet.</div>';
        return;
      }
      e.innerHTML = o.map((i) => this.renderPageRow(i)).join(""), e.querySelectorAll(".pl-pages-menu__row").forEach((i) => {
        const a = () => {
          const n = i.dataset.href;
          this.pagesMenu.close(), n && (window.location.href = n);
        };
        i.addEventListener("click", a), i.addEventListener("keydown", (n) => {
          (n.key === "Enter" || n.key === " ") && (n.preventDefault(), a());
        });
      });
    } catch (s) {
      if (!this.pagesMenu.isOpen()) return;
      e.innerHTML = `<div class="pl-pages-menu__status">Couldn't load pages.</div>`, R(this.deps.bus, "pages-menu.load", "Couldn't load the pages list.", s);
    }
  }
  renderPageRow(e) {
    const t = e.counts ?? {
      comments: 0,
      tasks: 0
    }, s = ve(e.key), o = e.title?.trim() || s, i = w(this.pageHref(e)), a = (n, l) => n > 0 ? `<span class="pl-pages-menu__count"><span class="pl-pages-menu__num">${n}</span><span class="pl-pages-menu__lbl">${n === 1 ? l : `${l}s`}</span></span>` : "";
    return `<div class="pl-pages-menu__row" role="button" tabindex="0" data-href="${i}"><div class="pl-pages-menu__top"><span class="pl-pages-menu__title">${w(o)}</span><span class="pl-pages-menu__counts">${a(t.comments, "comment")}${a(t.tasks, "task")}</span></div><span class="pl-sidebar__page-link pl-pages-menu__link"><span class="pl-sidebar__page-text">${w(s)}</span>${_("external-link", "pl-sidebar__page-ext")}</span></div>`;
  }
  pageHref(e) {
    return /^https?:\/\//i.test(e.key) ? e.key : G(this.deps, `/project/${encodeURIComponent(this.deps.project().slug)}/page/${encodeURIComponent(e.id)}`);
  }
  applyPosition(e) {
    for (const t of [
      "left",
      "right",
      "top",
      "bottom"
    ]) this.root.classList.toggle(`pl-sidebar--pos-${t}`, t === e);
  }
  applyDisplayMode(e) {
    this.root.classList.toggle("pl-sidebar--in-page", e === "in-page"), e === "in-page" ? this.enableInPagePadding() : this.disableInPagePadding();
  }
  enableInPagePadding() {
    if (this.inPageObservers) {
      this.reportSidebarContribution();
      return;
    }
    const e = new ResizeObserver(() => this.reportSidebarContribution());
    e.observe(this.root);
    const t = new MutationObserver(() => this.reportSidebarContribution());
    t.observe(this.root, {
      attributes: !0,
      attributeFilter: ["class"]
    });
    const s = () => this.reportSidebarContribution();
    window.addEventListener("resize", s), this.inPageObservers = {
      resizeObserver: e,
      mutationObserver: t,
      teardown: () => window.removeEventListener("resize", s)
    }, this.reportSidebarContribution();
  }
  disableInPagePadding() {
    const e = this.inPageObservers;
    e && (e.resizeObserver.disconnect(), e.mutationObserver.disconnect(), e.teardown(), this.inPageObservers = null), this.bodyPadding.set("sidebar", null);
  }
  reportSidebarContribution() {
    if (!this.inPageObservers) return;
    const e = this.currentPosition(), t = this.root.classList.contains("pl-sidebar--open"), s = e === "left" || e === "right", o = window.getComputedStyle(this.root), i = parseFloat(s ? o.width : o.height), a = this.root.getBoundingClientRect(), n = Number.isFinite(i) && i > 0 ? i : s ? a.width : a.height, l = t ? n : 0;
    this.bodyPadding.set("sidebar", {
      side: e,
      size: l
    });
  }
  get el() {
    return this.root;
  }
  toggleDisplayMode() {
    const e = (this.root.classList.contains("pl-sidebar--in-page") ? "in-page" : "flyout") == "in-page" ? "flyout" : "in-page";
    st(e), this.applyDisplayMode(e);
  }
  wireResizeHandle() {
    const e = this.root.querySelector(".pl-sidebar__resize");
    if (!e) return;
    const t = (s) => {
      s.preventDefault(), e.setPointerCapture(s.pointerId);
      const o = s.clientX, i = s.clientY, a = this.root.getBoundingClientRect(), n = a.width, l = a.height, d = this.currentPosition(), c = (m) => {
        let h;
        d === "right" ? h = n - (m.clientX - o) : d === "left" ? h = n + (m.clientX - o) : d === "top" ? h = l + (m.clientY - i) : h = l - (m.clientY - i);
        const b = d === "left" || d === "right", u = b ? window.innerWidth * 0.1 : window.innerHeight * 0.1, v = b ? window.innerWidth * 0.5 : window.innerHeight * 0.5, E = Math.max(u, Math.min(v, h));
        this.root.style.setProperty("--pl-sidebar-size", `${E}px`);
      }, p = () => {
        try {
          e.releasePointerCapture(s.pointerId);
        } catch {
        }
        document.removeEventListener("pointermove", c), document.removeEventListener("pointerup", p), document.removeEventListener("pointercancel", p), document.body.classList.remove("pl-resizing");
      };
      document.addEventListener("pointermove", c), document.addEventListener("pointerup", p), document.addEventListener("pointercancel", p), document.body.classList.add("pl-resizing");
    };
    e.addEventListener("pointerdown", t);
  }
  currentPosition() {
    return this.root.classList.contains("pl-sidebar--pos-left") ? "left" : this.root.classList.contains("pl-sidebar--pos-top") ? "top" : this.root.classList.contains("pl-sidebar--pos-bottom") ? "bottom" : "right";
  }
  toggle() {
    this.handle.toggle();
  }
  isOpen() {
    return this.root.classList.contains("pl-sidebar--open");
  }
  focusComment(e) {
    this.focusComments([e]);
  }
  async focusReply(e, t) {
    this.focusComments([e]), await Promise.resolve();
    const s = await this.commentsTab.replies.ensureExpanded(e);
    if (!s) return;
    await new Promise((i) => requestAnimationFrame(() => i()));
    const o = s.querySelector(`.pl-reply[data-reply-id="${t}"]`);
    o && (o.scrollIntoView({
      behavior: "smooth",
      block: "center"
    }), o.classList.add("is-focused"), setTimeout(() => o.classList.remove("is-focused"), 2500));
  }
  focusComments(e) {
    if (e.length === 0) return;
    const t = e[0];
    this.handle.open(), this.switchTab("comments"), this.render({
      ...this.state,
      focusedCommentId: t,
      focusedCommentIds: new Set(e)
    });
    const s = this.listEl.querySelector(`[data-comment-id="${t}"]`);
    s && s.scrollIntoView({
      behavior: "smooth",
      block: "center"
    }), this.actions.focusAnchor(t);
  }
  focusFirstInteractive() {
    if (this.root.contains(document.activeElement)) return;
    const e = this.root.querySelector('.pl-sidebar__tab[data-active="true"]') ?? this.root.querySelector(".pl-sidebar__close");
    e && requestAnimationFrame(() => e.focus());
  }
  switchTab(e) {
    this.activeTab = e, this.root.querySelectorAll(".pl-sidebar__tab").forEach((t) => {
      const s = t.dataset.tab === e;
      t.dataset.active = String(s), t.setAttribute("aria-selected", String(s));
    }), this.listEl.setAttribute("aria-labelledby", `pl-tab-${e}`), this.syncControls(), e === "changes" ? (this.closeCompose(), this.changesTab.render()) : this.render(this.state);
  }
  render(e) {
    if (this.state = e, this.notifyChatOfPageChange(e.page?.id ?? null), this.renderPageContext(e.page), this.syncControls(), this.syncFooterChat(), this.activeTab !== "comments") {
      this.closeCompose();
      return;
    }
    const t = this.showComments && this.showTasks ? e.comments : e.comments.filter((s) => s.isTask ? this.showTasks : this.showComments);
    this.commentsTab.render({
      ...e,
      comments: t
    }), this.ensureCompose(), this.updateComposePick(), this.updateComposeSubmitLabel();
  }
  updateComposePick() {
    const e = this.composeEl?.querySelector(".pl-compose__pick");
    e && (e.hidden = this.state.comments.length === 0);
  }
  syncControls() {
    if (!this.controlsEl) return;
    this.controlsEl.hidden = this.activeTab !== "comments";
    const e = (s, o) => {
      const i = this.controlsEl.querySelector(`.pl-filter-chip[data-filter="${s}"]`);
      i && (i.dataset.active = String(o), i.setAttribute("aria-pressed", String(o)), i.disabled = !1);
    };
    e("comments", this.showComments), e("tasks", this.showTasks);
    const t = this.controlsEl.querySelector(".pl-sidebar__agent-link");
    t && (t.hidden = !this.canModerate());
  }
  canModerate() {
    const e = this.deps.role();
    return e === "editor" || e === "owner" || this.deps.user()?.platformRole === "superadmin";
  }
  composeMode() {
    return this.showTasks && !this.showComments && this.canModerate() ? "task" : "comment";
  }
  updateComposeSubmitLabel() {
    const e = this.composeEl?.querySelector('[data-action="submit"]');
    e && !e.disabled && (e.textContent = this.composeMode() === "task" ? "Add Task" : "Comment");
  }
  renderPageContext(e) {
    if (!e) {
      this.pageEl.hidden = !0, this.pageEl.innerHTML = "", this.pageEl.removeAttribute("title");
      return;
    }
    const t = ve(e.key), s = `/project/${encodeURIComponent(this.deps.project().slug)}/page/${encodeURIComponent(e.id)}`, o = G(this.deps, s);
    this.pageEl.innerHTML = `<a class="pl-sidebar__page-link" href="${w(o)}" target="_blank" rel="noopener"><span class="pl-sidebar__page-text">${w(t)}</span>${_("external-link", "pl-sidebar__page-ext")}</a>`, this.pageEl.setAttribute("title", `Open in admin · ${e.key}`), this.pageEl.hidden = !1, this.pageEl.querySelector(".pl-sidebar__page-link")?.addEventListener("click", (i) => {
      i.preventDefault(), ee(this.deps, s);
    });
  }
  notifyChatOfPageChange(e) {
    if (e === this.lastSeenPageId) return;
    const t = this.lastSeenPageId === null;
    if (this.lastSeenPageId = e, !this.chatManager) {
      this.chatOpen && this.maybeMountChat();
      return;
    }
    t || this.chatManager.onPageChanged();
  }
  openCompose(e, t) {
    this.handle.open(), this.composeAnchor = e, this.ensureCompose(), this.renderComposeExcerpt(), this.persistDraft();
    const s = this.composeEl?.querySelector("textarea");
    s && requestAnimationFrame(() => {
      s.focus();
      const o = s.value.length;
      s.setSelectionRange(o, o);
    });
  }
  ensureCompose() {
    if (this.composeEl) return;
    const e = !this.deps.user(), t = !!this.deps.project().settings.policies?.publicComments, s = document.createElement("div");
    if (s.className = "pl-compose", e && !t) {
      s.innerHTML = '<div class="pl-compose__error">Sign in to comment on this page.</div>', this.composeEl = s, this.mountCompose(s);
      return;
    }
    const o = e && t ? `<input class="pl-compose__name" type="text" placeholder="Your name" maxlength="60" value="${w(S.getItem("pl_guest_name") ?? "")}">` : "";
    s.innerHTML = `
      <button type="button" class="pl-compose__pick" data-action="pick" hidden>${_("target")}<span>Pick an element to comment</span></button>
      <div class="pl-compose__quote" hidden>
        <div class="pl-compose__excerpt"></div>
        <button class="pl-compose__quote-clear" type="button" data-action="clear-anchor" aria-label="Remove quoted element" data-pl-tip="Remove quoted element">×</button>
      </div>
      ${o}
      <textarea class="pl-compose__textarea" placeholder="Write a comment..."></textarea>
      <div class="pl-compose__error" hidden></div>
      <div class="pl-compose__actions">
        <span class="pl-compose__hint">Ctrl+Enter to submit</span>
        <div class="pl-compose__actions-btns">
          <button class="pl-btn pl-compose__cancel" type="button" data-action="cancel">Cancel</button>
          <button class="pl-btn pl-btn--primary" data-action="submit">Comment</button>
        </div>
      </div>
    `, this.composeEl = s, this.mountCompose(s), s.querySelector('[data-action="pick"]')?.addEventListener("click", () => this.deps.bus.emit("sidebar:request-pick", {}));
    const i = s.querySelector("textarea"), a = s.querySelector(".pl-compose__name"), n = s.querySelector(".pl-compose__error"), l = s.querySelector('[data-action="submit"]'), d = s.querySelector('[data-action="cancel"]'), c = (m) => {
      n.textContent = m, n.hidden = !1;
    }, p = () => {
      n.hidden = !0, n.textContent = "";
    };
    i.addEventListener("input", () => this.scheduleDraftSave()), i.addEventListener("blur", () => this.persistDraft()), i.addEventListener("keydown", (m) => {
      (m.ctrlKey || m.metaKey) && m.key === "Enter" && (m.preventDefault(), l.click());
    }), s.querySelector('[data-action="clear-anchor"]')?.addEventListener("click", () => {
      this.composeAnchor = null, this.renderComposeExcerpt(), this.persistDraft(), i.focus();
    }), d.addEventListener("click", () => {
      i.value = "", this.composeAnchor = null, p(), this.renderComposeExcerpt(), this.updateComposePick(), this.clearDraftForPage(), i.focus();
    }), l.addEventListener("click", async () => {
      p();
      const m = i.value.trim();
      if (!m) {
        c("Write something first.");
        return;
      }
      let h;
      if (a) {
        if (h = a.value.trim(), !h) {
          c("Please enter your name."), a.focus();
          return;
        }
        S.setItem("pl_guest_name", h);
      }
      const b = this.composeMode() === "task";
      l.disabled = !0, l.textContent = b ? "Adding…" : "Posting…";
      try {
        let u = this.deps.page();
        if (!u) {
          if (this.deps.debug("compose.submit: no page; auto-registering"), u = await this.deps.registerCurrentPage(), !u) {
            c("Could not register this page. You may not have permission to comment here."), console.warn("[PageLoop] auto-register returned null; check role + project policies");
            return;
          }
          this.deps.debug("compose.submit: auto-registered", { pageId: u.id });
        }
        const v = await this.deps.comments.create({
          trackedPageId: u.id,
          anchor: this.composeAnchor,
          bodyMd: m,
          guestName: h
        });
        this.deps.debug("compose.submit: comment created"), b && (await this.deps.comments.setTask({
          commentId: v.id,
          isTask: !0
        }), this.deps.debug("compose.submit: promoted to task", { commentId: v.id })), i.value = "", this.composeAnchor = null, this.renderComposeExcerpt(), this.clearDraftForPage();
      } catch (u) {
        const v = u instanceof Error ? u.message : String(u);
        c(`Failed to post ${b ? "task" : "comment"}: ${v}`), console.error("[PageLoop] comments.create failed:", u);
      } finally {
        l.disabled = !1, l.textContent = this.composeMode() === "task" ? "Add Task" : "Comment";
      }
    }), this.restoreDraft(i), this.renderComposeExcerpt(), this.updateComposeSubmitLabel();
  }
  renderComposeExcerpt() {
    if (!this.composeEl) return;
    const e = this.composeEl.querySelector(".pl-compose__quote"), t = this.composeEl.querySelector(".pl-compose__excerpt");
    if (!(!e || !t))
      if (this.composeAnchor) {
        const s = this.composeAnchor.exact?.trim();
        t.textContent = s ? s.slice(0, 240) : "Attached to the selected element", e.hidden = !1;
      } else
        t.textContent = "", e.hidden = !0;
  }
  closeCompose() {
    this.composeEl?.remove(), this.composeEl = null, this.composeAnchor = null;
  }
  composeHasContent() {
    if (!this.composeEl) return !1;
    if (this.composeAnchor) return !0;
    const e = this.composeEl.querySelector("textarea");
    return !!e && e.value.trim().length > 0;
  }
  draftKeyParts() {
    try {
      const e = this.deps.project()?.id, t = this.deps.pageKey();
      return !e || !t ? null : {
        projectId: e,
        pageKey: t
      };
    } catch {
      return null;
    }
  }
  scheduleDraftSave() {
    this.draftSaveTimer && clearTimeout(this.draftSaveTimer), this.draftSaveTimer = setTimeout(() => {
      this.draftSaveTimer = null, this.persistDraft();
    }, 400);
  }
  persistDraft() {
    this.draftSaveTimer && (clearTimeout(this.draftSaveTimer), this.draftSaveTimer = null);
    const e = this.draftKeyParts();
    if (!e) return;
    const t = this.composeEl?.querySelector("textarea");
    os(e.projectId, e.pageKey, {
      bodyMd: t?.value ?? "",
      anchor: this.composeAnchor
    });
  }
  clearDraftForPage() {
    this.draftSaveTimer && (clearTimeout(this.draftSaveTimer), this.draftSaveTimer = null);
    const e = this.draftKeyParts();
    e && Oe(e.projectId, e.pageKey);
  }
  restoreDraft(e) {
    const t = this.draftKeyParts();
    if (!t) return;
    const s = ss(t.projectId, t.pageKey);
    s && (s.anchor && !this.composeAnchor && (this.composeAnchor = s.anchor), s.bodyMd && !e.value && (e.value = s.bodyMd));
  }
  mountCompose(e) {
    const t = this.root.querySelector(".pl-chat-panel__resizer");
    t ? this.root.insertBefore(e, t) : this.root.appendChild(e), this.pinFooterLast();
  }
  destroy() {
    this.disableInPagePadding(), document.removeEventListener("keydown", this.onEscapeKey), this.chatPanel?.destroy(), this.chatManager?.destroy(), this.chatPanel = null, this.chatManager = null, this.agentMenu.close(), this.footer?.destroy(), this.footer = null, this.root.remove();
  }
};
function ve(e) {
  try {
    const t = new URL(e), s = t.pathname === "/" ? "" : t.pathname.replace(/\/$/, "");
    return `${t.host}${s}${t.search}`;
  } catch {
    return e;
  }
}
var ye = {
  top: "paddingTop",
  right: "paddingRight",
  bottom: "paddingBottom",
  left: "paddingLeft"
}, ps = class {
  constructor() {
    r(this, "contributions", /* @__PURE__ */ new Map()), r(this, "previous", null), r(this, "throttleTimer", null), r(this, "styleObserver", null), r(this, "writing", !1), r(this, "expected", []);
  }
  set(e, t) {
    if (t === null) {
      if (!this.contributions.has(e)) return;
      this.contributions.delete(e);
    } else this.contributions.set(e, t);
    this.schedule();
  }
  get() {
    return this.contributions;
  }
  clear() {
    this.contributions.clear(), this.throttleTimer !== null && (window.clearTimeout(this.throttleTimer), this.throttleTimer = null), this.stopObserver(), this.expected = [], this.restoreIfCaptured();
  }
  startObserver() {
    this.styleObserver || typeof MutationObserver > "u" || (this.styleObserver = new MutationObserver(() => {
      if (this.writing) return;
      const e = document.body.style;
      for (const t of this.expected) if (e[ye[t.side]] !== t.px) {
        this.apply();
        return;
      }
    }), this.styleObserver.observe(document.body, {
      attributes: !0,
      attributeFilter: ["style"]
    }));
  }
  stopObserver() {
    this.styleObserver && (this.styleObserver.disconnect(), this.styleObserver = null);
  }
  schedule() {
    this.throttleTimer === null && (this.throttleTimer = window.setTimeout(() => {
      this.throttleTimer = null, this.apply();
    }, 20));
  }
  apply() {
    if (this.contributions.size === 0) {
      this.stopObserver(), this.expected = [], this.restoreIfCaptured();
      return;
    }
    this.captureIfNeeded();
    const e = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
    for (const s of this.contributions.values()) e[s.side] += Math.max(0, s.size);
    const t = document.body.style;
    this.writing = !0;
    try {
      Object.keys(e).forEach((s) => {
        t[ye[s]] = `${e[s]}px`;
      });
    } finally {
      this.writing = !1;
    }
    this.expected = Object.keys(e).map((s) => ({
      side: s,
      px: `${e[s]}px`
    })), this.startObserver();
  }
  captureIfNeeded() {
    if (this.previous) return;
    const e = document.body.style;
    this.previous = {
      top: e.paddingTop ?? "",
      right: e.paddingRight ?? "",
      bottom: e.paddingBottom ?? "",
      left: e.paddingLeft ?? ""
    };
  }
  restoreIfCaptured() {
    if (!this.previous) return;
    const e = document.body.style;
    e.paddingTop = this.previous.top, e.paddingRight = this.previous.right, e.paddingBottom = this.previous.bottom, e.paddingLeft = this.previous.left, this.previous = null;
  }
};
function hs(e) {
  if (!e) return null;
  const t = e.commonAncestorContainer;
  return t.nodeType === Node.ELEMENT_NODE ? t : t.parentElement;
}
var Be = class He {
  constructor(t, s, o, i = null) {
    r(this, "deps", void 0), r(this, "settings", void 0), r(this, "actions", void 0), r(this, "tooltip", void 0), r(this, "host", void 0), r(this, "bubbles", []), r(this, "byId", /* @__PURE__ */ new Map()), r(this, "seenBubbleIds", /* @__PURE__ */ new Set()), r(this, "anchors", /* @__PURE__ */ new Map()), r(this, "visible", void 0), r(this, "suppressed", !1), r(this, "lastComments", []), r(this, "baseResizeObserver", null), r(this, "baseInterval", null), r(this, "baselineIntervalMs", 3e3), r(this, "followAnimations", !1), r(this, "activeAnims", 0), r(this, "rafHandle", null), r(this, "stackPopover", null), r(this, "stackPopoverHideTimer", null), r(this, "mutationObserver", null), r(this, "pendingMutationRepaint", null), r(this, "scrollContainers", /* @__PURE__ */ new Map()), r(this, "bubbleParents", /* @__PURE__ */ new WeakMap()), r(this, "onAnimStart", () => {
      this.activeAnims++, this.rafHandle === null && this.startRafLoop();
    }), r(this, "onAnimEnd", () => {
      this.activeAnims = Math.max(0, this.activeAnims - 1);
    }), this.deps = t, this.settings = s, this.actions = o, this.tooltip = i, this.visible = S.getItem("pl_bubbles_hidden") !== "1", this.host = document.createElement("div"), this.host.style.position = "absolute", this.host.style.top = "0", this.host.style.left = "0", this.host.style.pointerEvents = "none", this.host.dataset.pageloop = "bubble-layer", document.body.appendChild(this.host), this.applyVisibility(), window.addEventListener("resize", () => this.reflow(), { passive: !0 }), window.addEventListener("scroll", () => this.reflow(), { passive: !0 }), document.addEventListener("scroll", () => this.reflow(), {
      capture: !0,
      passive: !0
    }), typeof document < "u" && "fonts" in document && document.fonts.ready?.then(() => this.reflow()).catch(() => {
    }), document.readyState !== "complete" && window.addEventListener("load", () => this.reflow(), { once: !0 }), setTimeout(() => this.reflow(), 750), s.subscribe(() => this.repaint()), t.bus.on("reply:created", () => this.repaint()), typeof ResizeObserver < "u" && (this.baseResizeObserver = new ResizeObserver(() => this.reflow()), this.baseResizeObserver.observe(document.body)), this.baseInterval = setInterval(() => this.reflow(), this.baselineIntervalMs), this.setFollowAnimations(t.ui().bubbleFollowAnimations === !0), typeof MutationObserver < "u" && (this.mutationObserver = new MutationObserver(() => this.queueMutationRepaint()), this.mutationObserver.observe(document.body, {
      childList: !0,
      subtree: !0,
      characterData: !1,
      attributes: !1
    }));
  }
  queueMutationRepaint() {
    this.pendingMutationRepaint || (this.pendingMutationRepaint = setTimeout(() => {
      this.pendingMutationRepaint = null, !this.lastComments.every((t) => this.byId.has(t.id)) && this.repaint();
    }, 200));
  }
  setFollowAnimations(t) {
    t !== this.followAnimations && (this.followAnimations = t, t ? this.attachFollowObservers() : this.detachFollowObservers());
  }
  attachFollowObservers() {
    document.addEventListener("transitionstart", this.onAnimStart, !0), document.addEventListener("animationstart", this.onAnimStart, !0), document.addEventListener("transitionend", this.onAnimEnd, !0), document.addEventListener("animationend", this.onAnimEnd, !0), document.addEventListener("transitioncancel", this.onAnimEnd, !0), document.addEventListener("animationcancel", this.onAnimEnd, !0);
  }
  detachFollowObservers() {
    document.removeEventListener("transitionstart", this.onAnimStart, !0), document.removeEventListener("animationstart", this.onAnimStart, !0), document.removeEventListener("transitionend", this.onAnimEnd, !0), document.removeEventListener("animationend", this.onAnimEnd, !0), document.removeEventListener("transitioncancel", this.onAnimEnd, !0), document.removeEventListener("animationcancel", this.onAnimEnd, !0), this.activeAnims = 0, this.stopRafLoop();
  }
  startRafLoop() {
    this.host.classList.add("pl-bubble-layer--snap");
    const t = () => {
      this.reflow(), this.activeAnims > 0 ? this.rafHandle = requestAnimationFrame(t) : (this.rafHandle = null, this.host.classList.remove("pl-bubble-layer--snap"));
    };
    this.rafHandle = requestAnimationFrame(t);
  }
  stopRafLoop() {
    this.rafHandle !== null && (cancelAnimationFrame(this.rafHandle), this.rafHandle = null), this.host.classList.remove("pl-bubble-layer--snap");
  }
  toggleVisible() {
    this.visible = !this.visible, S.setItem("pl_bubbles_hidden", this.visible ? "0" : "1"), this.applyVisibility(), this.deps.bus.emit("bubbles:toggle", { visible: this.visible });
  }
  isVisible() {
    return this.visible;
  }
  applyVisibility() {
    const t = !this.visible || this.suppressed;
    document.body.classList.toggle("pl-bubbles-hidden", t);
  }
  setSuppressed(t, s) {
    t !== this.suppressed && (typeof s == "number" ? document.body.style.setProperty("--pl-bubble-fade-ms", `${Math.max(0, s)}ms`) : document.body.style.removeProperty("--pl-bubble-fade-ms"), this.suppressed = t, this.applyVisibility());
  }
  render(t) {
    this.lastComments = t, this.repaint();
  }
  repaintForConfig() {
    this.repaint();
  }
  reflowNow() {
    this.reflow();
  }
  placeBubble(t, s, o) {
    let i, a, n;
    const l = o ? z(o) : null;
    if (!o || !l || l === document.documentElement)
      i = this.host, a = window.scrollY + s.top + s.height / 2, n = window.scrollX + s.left;
    else {
      window.getComputedStyle(l).position === "static" && (l.style.position = "relative");
      const d = l.getBoundingClientRect();
      a = s.top - d.top + l.scrollTop + s.height / 2, n = s.left - d.left + l.scrollLeft, i = l;
    }
    t.parentElement !== i && i.appendChild(t), t.style.setProperty("--pl-bubble-x", `${n}px`), t.style.setProperty("--pl-bubble-y", `${a}px`), this.bubbleParents.set(t, i);
  }
  bindScrollersForAnchors(t) {
    const s = /* @__PURE__ */ new Set();
    for (const o of t) {
      if (!o.element) continue;
      const i = z(o.element);
      i !== document.documentElement && s.add(i);
    }
    for (const o of s) {
      if (this.scrollContainers.has(o)) continue;
      const i = () => this.reflow();
      o.addEventListener("scroll", i, { passive: !0 }), this.scrollContainers.set(o, i);
    }
    for (const [o, i] of this.scrollContainers)
      s.has(o) || (o.removeEventListener("scroll", i), this.scrollContainers.delete(o));
  }
  reflow() {
    const t = this.host.classList.contains("pl-bubble-layer--snap");
    for (const s of this.lastComments) {
      const o = this.byId.get(s.id), i = this.anchors.get(s.id);
      if (!o || !i) continue;
      const a = W(i.range, i.element);
      if (!a) continue;
      const n = o.style.getPropertyValue("--pl-bubble-x"), l = o.style.getPropertyValue("--pl-bubble-y"), d = n !== "" && l !== "", c = parseFloat(l || "0"), p = parseFloat(n || "0");
      this.placeBubble(o, a, i.element), this.clampBubbleToViewport(o);
      const m = parseFloat(o.style.getPropertyValue("--pl-bubble-y") || "0"), h = parseFloat(o.style.getPropertyValue("--pl-bubble-x") || "0") - p, b = m - c;
      d && Math.abs(h) + Math.abs(b) >= He.SHIFT_THRESHOLD_PX && !t && this.pulseBubbleShift(o);
    }
  }
  pulseBubbleShift(t) {
    t.classList.remove("pl-bubble--shifting"), t.offsetWidth, t.classList.add("pl-bubble--shifting");
  }
  clampBubbleToViewport(t) {
    const o = t.getBoundingClientRect();
    if (o.width === 0 && o.height === 0) return;
    const i = window.innerWidth;
    let a = 0;
    if (o.left < 3 ? a = 3 - o.left : o.right > i - 3 && (a = i - 3 - o.right), a === 0) return;
    const n = o.width / 2;
    a > n ? a = n : a < -n && (a = -n);
    const l = parseFloat(t.style.getPropertyValue("--pl-bubble-x")) || 0;
    t.style.setProperty("--pl-bubble-x", `${l + a}px`);
  }
  repaint() {
    for (const n of this.bubbles) n.remove();
    this.bubbles = [], this.byId.clear(), this.anchors.clear(), this.hideStackPopover();
    const t = [], s = /* @__PURE__ */ new Set();
    for (const n of this.lastComments) {
      if (!n.anchor) continue;
      const l = ft(n.anchor), d = W(l.range, l.element), c = l.element ?? hs(l.range);
      if (!d || !at(c, d)) {
        s.add(n.id);
        continue;
      }
      t.push({
        comment: n,
        range: l.range,
        element: c,
        target: d
      }), this.anchors.set(n.id, {
        range: l.range,
        element: c
      });
    }
    this.deps.bus.emit("bubbles:dangling", { ids: s }), this.bindScrollersForAnchors(t);
    const o = /* @__PURE__ */ new Map();
    for (const n of t) {
      const l = `${Math.round(n.target.top)}:${Math.round(n.target.left)}`, d = o.get(l);
      d ? d.push(n) : o.set(l, [n]);
    }
    const i = this.deps.ui().allowInlineCommenting === !0, a = this.settings.get().showReplyCountInBubbles;
    for (const n of o.values()) {
      const l = n[0], d = n.map((m) => m.comment.id), c = n.length > 1, p = document.createElement("button");
      if (p.className = "pl-bubble", c && (p.classList.add("pl-bubble--stack"), p.dataset.stackSize = String(n.length)), c)
        p.textContent = String(n.length), p.classList.add("pl-bubble--count");
      else {
        const m = this.deps.comments.loadedReplies(l.comment.id);
        a && m !== null ? (p.textContent = String(m.length), p.classList.add("pl-bubble--count")) : p.textContent = q(l.comment.authorName);
      }
      p.style.pointerEvents = "auto", this.placeBubble(p, l.target, l.element ?? null), c ? (p.addEventListener("mouseenter", () => this.showStackPopover(p, n)), p.addEventListener("mouseleave", () => this.queueHideStackPopover()), p.addEventListener("click", () => {
        this.hideStackPopover(), this.actions.onClickBubble(d);
      })) : (this.tooltip?.bind(p, l.comment, { bindClick: i }), i || p.addEventListener("click", () => this.actions.onClickBubble([l.comment.id]))), this.clampBubbleToViewport(p), this.bubbles.push(p), d.some((m) => !this.seenBubbleIds.has(m)) && p.classList.add("pl-bubble--new");
      for (const m of d)
        this.byId.set(m, p), this.seenBubbleIds.add(m);
    }
    typeof requestAnimationFrame < "u" && requestAnimationFrame(() => this.reflow());
  }
  showStackPopover(t, s) {
    if (this.stackPopoverHideTimer && (clearTimeout(this.stackPopoverHideTimer), this.stackPopoverHideTimer = null), !this.stackPopover) {
      const c = document.createElement("div");
      c.className = "pl-stack-popover", c.style.position = "absolute", c.style.pointerEvents = "auto", c.addEventListener("mouseenter", () => {
        this.stackPopoverHideTimer && (clearTimeout(this.stackPopoverHideTimer), this.stackPopoverHideTimer = null);
      }), c.addEventListener("mouseleave", () => this.queueHideStackPopover()), this.host.appendChild(c), this.stackPopover = c;
    }
    const o = this.stackPopover, i = (c) => c.replace(/[&<>"]/g, (p) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;"
    })[p]), a = (c, p) => c.length > p ? `${c.slice(0, p - 1)}…` : c;
    o.innerHTML = `
			<div class="pl-stack-popover__head">${s.length} comments at this spot</div>
			<div class="pl-stack-popover__rows">
				${s.map((c) => `
				<button type="button" class="pl-stack-popover__row" data-comment-id="${c.comment.id}">
					<span class="pl-stack-popover__avatar">${i(q(c.comment.authorName))}</span>
					<span class="pl-stack-popover__body">
						<span class="pl-stack-popover__author">${i(Q(c.comment.authorName))}</span>
						<span class="pl-stack-popover__text">${i(a(c.comment.bodyMd ?? "", 80))}</span>
					</span>
				</button>`).join("")}
			</div>
		`, o.querySelectorAll("[data-comment-id]").forEach((c) => {
      c.addEventListener("click", () => {
        const p = c.dataset.commentId;
        this.hideStackPopover(), this.actions.onClickBubble([p]);
      });
    });
    const n = t.getBoundingClientRect();
    o.style.top = `${window.scrollY + n.bottom + 6}px`, o.style.left = `${window.scrollX + n.left}px`, o.style.display = "block";
    const l = o.getBoundingClientRect(), d = window.innerWidth;
    l.right > d - 6 ? o.style.left = `${window.scrollX + Math.max(6, d - l.width - 6)}px` : l.left < 6 && (o.style.left = `${window.scrollX + 6}px`);
  }
  queueHideStackPopover() {
    this.stackPopoverHideTimer && clearTimeout(this.stackPopoverHideTimer), this.stackPopoverHideTimer = setTimeout(() => this.hideStackPopover(), 140);
  }
  hideStackPopover() {
    this.stackPopoverHideTimer && (clearTimeout(this.stackPopoverHideTimer), this.stackPopoverHideTimer = null), this.stackPopover && (this.stackPopover.style.display = "none");
  }
  focusAnchor(t) {
    const s = this.anchors.get(t), o = this.byId.get(t);
    if (!s) return;
    const i = W(s.range, s.element);
    if (i) {
      const a = window.innerHeight;
      if (!(i.top >= 0 && i.bottom <= a)) {
        const n = z(s.element), l = n === document.documentElement ? null : n.getBoundingClientRect(), d = a / 3;
        if (l) {
          const c = i.top - l.top - d;
          n.scrollTo({
            top: n.scrollTop + c,
            behavior: "smooth"
          });
        } else {
          const c = window.scrollY + i.top - d;
          window.scrollTo({
            top: Math.max(0, c),
            behavior: "smooth"
          });
        }
      }
    }
    o && (o.classList.remove("pl-bubble--flash", "pl-bubble--focus-pulse"), o.offsetWidth, o.classList.add("pl-bubble--flash", "pl-bubble--focus-pulse"), setTimeout(() => o.classList.remove("pl-bubble--flash", "pl-bubble--focus-pulse"), 1300)), ze(s.range, s.element);
  }
  celebrateAt(t) {
    if (typeof matchMedia < "u" && matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const s = this.byId.get(t);
    if (!s) return;
    const o = document.createElement("div");
    o.className = "pl-confetti";
    const i = 10;
    for (let a = 0; a < i; a++) {
      const n = document.createElement("i"), l = 360 / i * a + (Math.random() * 24 - 12), d = 26 + Math.random() * 18, c = l * Math.PI / 180;
      n.style.setProperty("--pl-cdx", `${Math.cos(c) * d}px`), n.style.setProperty("--pl-cdy", `${Math.sin(c) * d}px`), n.style.setProperty("--pl-crot", `${Math.random() * 360}deg`), n.style.setProperty("--pl-cdelay", `${Math.random() * 60}ms`), n.dataset.hue = String(a % 4), o.appendChild(n);
    }
    s.appendChild(o), setTimeout(() => o.remove(), 1100);
  }
  destroy() {
    this.detachFollowObservers(), this.baseResizeObserver?.disconnect(), this.baseResizeObserver = null, this.baseInterval !== null && (clearInterval(this.baseInterval), this.baseInterval = null), this.mutationObserver?.disconnect(), this.mutationObserver = null, this.pendingMutationRepaint && (clearTimeout(this.pendingMutationRepaint), this.pendingMutationRepaint = null);
    for (const [t, s] of this.scrollContainers) t.removeEventListener("scroll", s);
    this.scrollContainers.clear(), this.host.remove();
  }
};
r(Be, "SHIFT_THRESHOLD_PX", 2);
var we = "pl_first_select_nudge_v1", us = class {
  constructor(e) {
    r(this, "actions", void 0), r(this, "el", null), r(this, "coachEl", null), r(this, "onSelectionChange", () => {
      const t = window.getSelection();
      (!t || t.isCollapsed) && this.hide();
    }), r(this, "onMouseUp", () => {
      setTimeout(() => {
        const t = window.getSelection();
        if (!t || t.isCollapsed || !t.toString().trim()) {
          this.hide();
          return;
        }
        const s = t.getRangeAt(0);
        if ((s.commonAncestorContainer.nodeType === Node.ELEMENT_NODE ? s.commonAncestorContainer : s.commonAncestorContainer.parentElement)?.closest(".pl-sidebar, .pl-toolbar")) return;
        const o = s.getBoundingClientRect();
        this.show(o.left + window.scrollX, o.top + window.scrollY, () => {
          this.actions.onComment(ct(s.cloneRange())), this.hide(), t.removeAllRanges();
        });
      }, 10);
    }), this.actions = e, document.addEventListener("mouseup", this.onMouseUp), document.addEventListener("selectionchange", this.onSelectionChange);
  }
  show(e, t, s) {
    this.hide();
    const o = document.createElement("button");
    o.className = "pl-floating-action", o.type = "button", o.innerHTML = `${_("chat-bubble")}<span class="pl-floating-action__label">Comment on this</span>`, o.style.left = `${e}px`, o.style.top = `${t}px`, o.addEventListener("mousedown", (i) => {
      i.preventDefault(), s();
    }), document.body.appendChild(o), this.el = o, this.maybeNudge(o);
  }
  maybeNudge(e) {
    const t = this.actions.context?.();
    if (!t || !t.canComment || t.hasComments || S.getItem(we) === "1") return;
    S.setItem(we, "1"), e.classList.add("pl-floating-action--nudge");
    const s = document.createElement("div");
    s.className = "pl-coachmark", s.textContent = "Highlight anything to leave a note", s.style.left = e.style.left, s.style.top = e.style.top, document.body.appendChild(s), this.coachEl = s;
  }
  hide() {
    this.el?.remove(), this.el = null, this.coachEl?.remove(), this.coachEl = null;
  }
  destroy() {
    document.removeEventListener("mouseup", this.onMouseUp), document.removeEventListener("selectionchange", this.onSelectionChange), this.hide();
  }
}, qe = ".pl-sidebar, .pl-toolbar, .pl-bubble, .pl-floating-action, .pl-mini";
function ms(e, t, s) {
  let o = s;
  for (let i = 0; i < 200; i++) {
    const a = o.children;
    let n = null;
    for (let l = a.length - 1; l >= 0; l--) {
      const d = a[l];
      if (d.closest(qe)) continue;
      const c = d.getBoundingClientRect();
      if (!(c.width === 0 && c.height === 0) && e >= c.left && e <= c.right && t >= c.top && t <= c.bottom) {
        n = d;
        break;
      }
    }
    if (!n) return o;
    o = n;
  }
  return o;
}
var bs = class {
  constructor(e) {
    r(this, "actions", void 0), r(this, "active", !1), r(this, "hovered", null), r(this, "onMove", (t) => {
      const s = this.resolveTarget(t);
      !s || s === this.hovered || (this.hovered?.classList.remove("pl-element-hover"), this.hovered = s, s.classList.add("pl-element-hover"));
    }), r(this, "onClick", (t) => {
      const s = this.resolveTarget(t);
      s && (t.preventDefault(), t.stopPropagation(), this.actions.onPick(dt(s)), this.toggle());
    }), r(this, "onKeyDown", (t) => {
      t.key === "Escape" && (t.preventDefault(), t.stopPropagation(), this.cancel());
    }), r(this, "onContextMenu", (t) => {
      t.preventDefault(), t.stopPropagation(), this.cancel();
    }), this.actions = e;
  }
  toggle() {
    this.active = !this.active, document.body.style.cursor = this.active ? "crosshair" : "", this.active ? (document.addEventListener("mousemove", this.onMove), document.addEventListener("click", this.onClick, !0), document.addEventListener("keydown", this.onKeyDown, !0), document.addEventListener("contextmenu", this.onContextMenu, !0)) : this.cleanup();
  }
  resolveTarget(e) {
    let t = e.target ?? document.elementFromPoint(e.clientX, e.clientY);
    return !t || t.closest(qe) ? null : ms(e.clientX, e.clientY, t);
  }
  cancel() {
    this.active && (this.toggle(), this.actions.onCancel?.());
  }
  cleanup() {
    document.removeEventListener("mousemove", this.onMove), document.removeEventListener("click", this.onClick, !0), document.removeEventListener("keydown", this.onKeyDown, !0), document.removeEventListener("contextmenu", this.onContextMenu, !0), this.hovered?.classList.remove("pl-element-hover"), this.hovered = null;
  }
  destroy() {
    this.cleanup();
  }
}, ne = class J {
  constructor() {
    r(this, "deps", null), r(this, "toolbar", null), r(this, "sidebar", null), r(this, "bubbles", null), r(this, "selection", null), r(this, "picker", null), r(this, "reanchorTarget", null), r(this, "commentTooltip", null), r(this, "settings", new Ye()), r(this, "toaster", new Ft()), r(this, "bodyPadding", new ps()), r(this, "offConfig", null), r(this, "offTooltip", null), r(this, "offSettings", null), r(this, "offBubbleRecolor", null), r(this, "themeMql", null), r(this, "themeMqlListener", null), r(this, "toolbarActions", null), r(this, "lastUnreadCount", 0), r(this, "lastBubblesVisible", !0), r(this, "lastConnection", null);
  }
  async mount(t) {
    this.deps = t, typeof document < "u" && document.readyState === "loading" && await new Promise((i) => {
      document.addEventListener("DOMContentLoaded", () => i(), { once: !0 });
    }), this.applyTheme(this.settings.get().theme, t.ui().theme ?? "auto"), this.toaster.attach(t.bus), this.offTooltip = $t.install();
    const s = () => {
      const i = this.settings.get();
      document.body.style.setProperty("--pl-bubble-size", `${Ve[i.bubbleSize]}px`), document.body.style.setProperty("--pl-bubble-font", `${Qe[i.bubbleSize]}px`), document.body.style.setProperty("--pl-text-scale", String(tt[i.textSize]));
    };
    s(), this.applyBubbleColor(t.bubbleColor()), this.offBubbleRecolor = t.bus.on("bubbles:recolor", (i) => {
      this.applyBubbleColor(i?.color ?? null);
    }), this.offSettings = this.settings.subscribe((i) => {
      s(), this.applyTheme(i.theme, t.ui().theme ?? "auto"), this.applyWidgetMode(t), this.applySidebarLayout(t), this.swapToolbarSurface(), this.updateMiniCorner();
    }), this.applyWidgetMode(t), this.applyBubbleZIndex(t.ui().bubbleZIndex), this.sidebar = new ds(t, this.settings, {
      focusAnchor: (i) => this.bubbles.focusAnchor(i),
      controls: {
        closeSidebar: () => this.sidebar?.handle.close(),
        togglePicker: () => {
          this.reanchorTarget = null, this.picker?.toggle();
        },
        toggleBubbles: () => this.bubbles?.toggleVisible()
      }
    }, this.bodyPadding), this.applySidebarLayout(t), this.commentTooltip = new Ht(t.comments, {
      delayMs: t.ui().tooltipDelayMs ?? 200,
      replyAffordance: () => t.ui().allowInlineCommenting !== !0 ? "hidden" : t.user() ? "user" : t.project().settings.policies?.publicComments === !0 ? "guest" : "hidden",
      placement: "top"
    }), this.commentTooltip.setOpenSidebar((i) => this.sidebar.focusComment(i)), this.bubbles = new Be(t, this.settings, { onClickBubble: (i) => this.sidebar.focusComments(i) }, this.commentTooltip), this.toolbarActions = {
      toggleSidebar: () => this.sidebar.toggle(),
      togglePicker: () => {
        this.reanchorTarget = null, this.picker.toggle();
      },
      toggleBubbles: () => this.bubbles.toggleVisible(),
      bulkClear: async (i) => {
        const a = t.page();
        if (a && !(i && !Z(i, "Click again to delete ALL · Esc to cancel")))
          try {
            const { deleted: n } = await t.comments.bulkDeleteForPage(a.id);
            t.debug("toolbar.bulkClear: deleted", n), t.bus.emit("toast:show", {
              kind: "info",
              message: n === 1 ? "1 comment cleared" : `${n} comments cleared`
            });
          } catch (n) {
            R(t.bus, "comments.bulkClear", `Failed to clear comments: ${n instanceof Error ? n.message : String(n)}`, n);
          }
      }
    };
    const o = this.effectiveWidgetMode();
    return this.toolbar = o === "mini" ? new F(t, this.settings, this.toolbarActions) : new ge(t, this.settings, this.toolbarActions), this.syncToolbarVisibility(), t.bus.on("sidebar:toggle", () => this.syncToolbarVisibility()), this.selection = new us({
      onComment: (i) => this.sidebar.openCompose(i, null),
      context: () => {
        const i = t.role(), a = t.page();
        return {
          canComment: i === "owner" || i === "editor" || i === "commenter",
          hasComments: a ? t.comments.load(a.id).length > 0 : !1
        };
      }
    }), this.picker = new bs({
      onPick: (i) => {
        const a = this.reanchorTarget;
        if (this.reanchorTarget = null, a) {
          t.comments.update({
            commentId: a,
            anchor: i
          }).then(() => {
            t.bus.emit("toast:show", {
              kind: "success",
              message: "Comment re-anchored."
            });
          }).catch((n) => R(t.bus, "comment.reanchor", "Couldn't re-anchor the comment.", n, { extra: { commentId: a } }));
          return;
        }
        this.sidebar.openCompose(i, null);
      },
      onCancel: () => {
        this.reanchorTarget = null;
      }
    }), t.bus.on("connection:open", (i) => {
      this.lastConnection = i.transport, this.toolbar?.setConnection(i.transport);
    }), t.bus.on("connection:closed", () => {
      this.lastConnection = null, this.toolbar?.setConnection(null);
    }), t.bus.on("connection:reconnecting", () => {
      this.toolbar?.setReconnecting();
    }), t.bus.on("sidebar:request-pick", () => {
      this.reanchorTarget = null, this.picker?.toggle();
    }), t.bus.on("sidebar:request-reanchor", ({ commentId: i }) => {
      this.reanchorTarget = i, this.picker?.toggle();
    }), t.bus.on("comment:created", (i) => this.maybeCelebrateFirstComment(i)), this.offConfig = t.bus.on("config:changed", () => {
      const i = t.ui();
      this.applyTheme(this.settings.get().theme, i.theme ?? "auto"), this.applyWidgetMode(t), this.applySidebarLayout(t), this.applyBubbleZIndex(i.bubbleZIndex), this.commentTooltip?.updateOptions({ delayMs: i.tooltipDelayMs ?? 200 }), this.bubbles?.setFollowAnimations(i.bubbleFollowAnimations === !0), this.bubbles?.repaintForConfig();
    }), {
      toolbar: {
        setUnreadCount: (i) => {
          this.lastUnreadCount = i, this.toolbar?.handle.setUnreadCount(i);
        },
        setBubblesVisible: (i) => {
          this.lastBubblesVisible = i, this.toolbar?.handle.setBubblesVisible(i);
        }
      },
      sidebar: this.sidebar.handle
    };
  }
  effectiveWidgetMode() {
    const t = this.settings.get().widgetModeOverride;
    return t === "docked" || t === "mini" ? t : this.deps?.ui()?.widgetMode ?? "docked";
  }
  effectiveWidgetCorner() {
    const t = this.settings.get().widgetCornerOverride;
    return t === "lower-right" || t === "lower-left" || t === "upper-right" || t === "upper-left" ? t : this.deps?.ui()?.widgetCorner ?? "lower-right";
  }
  swapToolbarSurface() {
    if (!this.deps || !this.toolbarActions) return;
    const t = this.effectiveWidgetMode();
    t !== (this.toolbar instanceof F ? "mini" : "docked") && (this.toolbar?.destroy(), this.toolbar = t === "mini" ? new F(this.deps, this.settings, this.toolbarActions) : new ge(this.deps, this.settings, this.toolbarActions), this.toolbar.handle.setUnreadCount(this.lastUnreadCount), this.toolbar.handle.setBubblesVisible(this.lastBubblesVisible), this.toolbar.setConnection(this.lastConnection), this.applyWidgetMode(this.deps), this.syncToolbarVisibility());
  }
  syncToolbarVisibility() {
    this.toolbar?.setHidden(this.sidebar?.isOpen() ?? !1), this.effectiveWidgetMode() === "docked" && this.applyToolbarPosition(this.deps?.ui().toolbarPosition ?? "top");
  }
  updateMiniCorner() {
    this.toolbar instanceof F && (this.toolbar.updateCorner(this.effectiveWidgetCorner()), this.deps && this.applyWidgetMode(this.deps));
  }
  applyToolbarPosition(t) {
    const s = this.settings.get().toolbarPositionOverride ?? t;
    s === "bottom" ? (document.body.classList.add("pl-toolbar-bottom"), document.body.classList.remove("pl-toolbar-top")) : (document.body.classList.add("pl-toolbar-top"), document.body.classList.remove("pl-toolbar-bottom"));
    const o = this.sidebar?.isOpen() ?? !1;
    this.bodyPadding.set("toolbar", o ? null : {
      side: s,
      size: 40
    });
  }
  applyWidgetMode(t) {
    const s = t.ui(), o = this.effectiveWidgetMode(), i = this.effectiveWidgetCorner(), a = document.body;
    for (const n of [
      "pl-widget-corner-lower-right",
      "pl-widget-corner-lower-left",
      "pl-widget-corner-upper-right",
      "pl-widget-corner-upper-left"
    ]) a.classList.remove(n);
    o === "mini" ? (a.classList.add("pl-widget-mode-mini"), a.classList.remove("pl-widget-mode-docked"), a.classList.add(`pl-widget-corner-${i}`), a.classList.remove("pl-toolbar-top"), a.classList.remove("pl-toolbar-bottom"), this.bodyPadding.set("toolbar", {
      side: "top",
      size: 0
    })) : (a.classList.add("pl-widget-mode-docked"), a.classList.remove("pl-widget-mode-mini"), this.applyToolbarPosition(s.toolbarPosition ?? "top"));
  }
  applySidebarLayout(t) {
    if (!this.sidebar) return;
    const s = t.ui(), o = this.settings.get().sidebarPositionOverride ?? s.sidebarPosition ?? s.sidebarSide ?? "right";
    this.sidebar.applyPosition(o);
    const i = Ge() ?? s.sidebarDisplayMode ?? "flyout";
    this.sidebar.applyDisplayMode(i);
  }
  applyTheme(t, s) {
    const o = Wt(t || s, "auto");
    this.applyBuiltInTheme(o.base), pe(o.overlayCss);
  }
  applyBubbleColor(t) {
    const s = document.body.style;
    if (!t || !/^#[0-9a-fA-F]{6}$/.test(t)) {
      s.removeProperty("--pl-bubble-base"), s.removeProperty("--pl-bubble-bg"), s.removeProperty("--pl-bubble-ring");
      return;
    }
    s.setProperty("--pl-bubble-base", t), s.setProperty("--pl-bubble-bg", `linear-gradient(135deg, ${t} 0%, ${gs(t, 0.28)} 100%)`), s.setProperty("--pl-bubble-ring", fs(t, 0.55));
  }
  applyBuiltInTheme(t) {
    const s = (a) => {
      document.body.setAttribute("data-pl-theme", a), document.documentElement.setAttribute("data-pl-theme", a);
    };
    if (this.themeMql && this.themeMqlListener && (this.themeMql.removeEventListener("change", this.themeMqlListener), this.themeMql = null, this.themeMqlListener = null), t === "dark") {
      s("dark");
      return;
    }
    if (t === "light") {
      s("light");
      return;
    }
    if (typeof window > "u" || typeof window.matchMedia != "function") {
      s("light");
      return;
    }
    const o = window.matchMedia("(prefers-color-scheme: dark)");
    s(o.matches ? "dark" : "light");
    const i = (a) => s(a.matches ? "dark" : "light");
    o.addEventListener("change", i), this.themeMql = o, this.themeMqlListener = i;
  }
  applyBubbleZIndex(t) {
    if (typeof document > "u") return;
    const s = document.documentElement;
    if (t == null || !Number.isFinite(t)) {
      s.style.removeProperty("--pl-z-bubbles"), s.style.removeProperty("--pl-z-floating");
      return;
    }
    const o = Math.max(0, Math.min(2147483647, Math.floor(t))), i = Math.min(2147483647, o + 1);
    s.style.setProperty("--pl-z-bubbles", String(o)), s.style.setProperty("--pl-z-floating", String(i));
  }
  async unmount() {
    this.themeMql && this.themeMqlListener && this.themeMql.removeEventListener("change", this.themeMqlListener), this.offConfig?.(), this.offConfig = null, this.offTooltip?.(), this.offTooltip = null, this.offSettings?.(), this.offSettings = null, this.offBubbleRecolor?.(), this.offBubbleRecolor = null, document.body.style.removeProperty("--pl-bubble-size"), document.body.style.removeProperty("--pl-bubble-font"), document.body.style.removeProperty("--pl-text-scale"), document.body.style.removeProperty("--pl-bubble-base"), document.body.style.removeProperty("--pl-bubble-bg"), document.body.style.removeProperty("--pl-bubble-ring"), document.documentElement.style.removeProperty("--pl-z-bubbles"), document.documentElement.style.removeProperty("--pl-z-floating"), document.body.removeAttribute("data-pl-theme"), document.documentElement.removeAttribute("data-pl-theme"), pe(null), document.body.classList.remove("pl-toolbar-bottom"), document.body.classList.remove("pl-toolbar-top"), this.bodyPadding.clear(), this.toolbar?.destroy(), this.sidebar?.destroy(), this.bubbles?.destroy(), this.commentTooltip?.destroy(), this.commentTooltip = null, this.selection?.destroy(), this.picker?.destroy(), this.toaster.destroy();
  }
  renderBubbles(t) {
    this.bubbles?.render(t);
  }
  renderSidebar(t) {
    this.sidebar?.render(t);
  }
  maybeCelebrateFirstComment(t) {
    if (!this.deps || S.getItem(J.ONBOARDED_KEY) === "1") return;
    const s = this.deps.user();
    (s ? t.authorId === s.id : t.authorName && t.authorName === (S.getItem("pl_guest_name") ?? "").trim()) && (S.setItem(J.ONBOARDED_KEY, "1"), this.deps.bus.emit("toast:show", {
      kind: "success",
      message: "Nice — your first note is live. Others can reply right here."
    }), requestAnimationFrame(() => requestAnimationFrame(() => this.bubbles?.celebrateAt(t.id))));
  }
  reflowBubbles() {
    this.bubbles?.reflowNow();
  }
  setBubblesHidden(t, s) {
    this.bubbles?.setSuppressed(t, s);
  }
};
r(ne, "ONBOARDED_KEY", "pl_first_comment_done_v1");
function Ne(e) {
  return [
    parseInt(e.slice(1, 3), 16),
    parseInt(e.slice(3, 5), 16),
    parseInt(e.slice(5, 7), 16)
  ];
}
function gs(e, t) {
  const [s, o, i] = Ne(e), a = (l) => Math.max(0, Math.min(255, Math.round(l * (1 - t)))), n = (l) => a(l).toString(16).padStart(2, "0");
  return `#${n(s)}${n(o)}${n(i)}`;
}
function fs(e, t) {
  const [s, o, i] = Ne(e);
  return `rgba(${s}, ${o}, ${i}, ${t})`;
}
function vs(e) {
  const t = new ke(e, { renderer: new ne() });
  return t.start(), t;
}
var ks = {
  init: vs,
  PageLoop: ke,
  VanillaRenderer: ne
};
export {
  Ht as CommentTooltip,
  ke as PageLoop,
  $t as Tooltip,
  ne as VanillaRenderer,
  ks as default,
  vs as init
};
